<template>
  <div class="home" v-if="isData">
    <van-dialog :closeOnClickOverlay="true" :showConfirmButton="false" v-model="show">
      <div class="table-dialog-content">

        <div class="table-header clear"><img @click="show = false" class="close-dialog-btn"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAB0ElEQVRYR73Yv0oDQRAG8G9SnoUWNgd5BAVBwdI/pLUWW2tbSztrn0Kwt42IWFqIoJI3uATExCJNwsrIHme4XG5vd/buNmXCXn75dnZ2CA2HwwsiugbwopQ663a73wj4mkwmG7PZ7BbALoArGo1GUwBrmeFNKdULhcowfQB72fdPNUi/0cuFEgRVggERPVOSJJudTkejdkKhyjAAPpj5mDQiJKoKE8fxVwoKhbJhtGMBahvlglkBtYVyxZSCmkZJMEZQUygpphJUF+WDsYJ8Ub4YJ5AUVQfjDHJFjcfj9fl8/pC7m/TStAPrpudyZy/1IduCqo4eRZGqixElZOno7wB+C/ehKJn/54sSsqDyAXthvBIqoB4BbBe2esDMB641UywTr4T0Q7ICfipsU1rESqlD3yHPC2Q4Tfkf6z3kiUEGzCAr6q2cygslAlX1GWbmJiZPZ5BL02ti8nQCuWAsLcF5+6wgCaYJVCXIB1MXZQTVwdRBlYIMmE9mPpJ2YGmhr4CaxPgktQRqAyNFLUBtYiSoFBQC44qikBgXlP475h7ASe5S9DpNtvG3+Lnh9PU1KAEQZwuCYCqS+tGgcwA3AF6Z+VTaZ6TJGJK6A7BPRJd/7NOPSvRfo2sAAAAASUVORK5CYII="
            alt="关闭">
          <p class="table-title">{{ title }}</p>
        </div>
        <div class="dialog-scroll-box">
          <div v-if="title == '立案详情'" class="table table-body">
            <div class="tr">
              <div class="td">案号</div>
              <div class="td">{{ sfinfoobj.case_no }}</div>
            </div>
            <div class="tr">
              <div class="td">案由</div>
              <div class="td">{{ sfinfoobj.reason }}</div>
            </div>
            <div class="tr">
              <div class="td">立案时间</div>
              <div class="td">{{ sfinfoobj.publish_date }}</div>
            </div>
            <div class="tr">
              <div class="td">原告/上诉人/再审申请人/申请人/公诉人</div>
              <div class="td">
                <p v-for="(item, index22) in sfinfoobj.prosecutor_list" :key="index22">{{ item }}</p>
              </div>
            </div>
            <div class="tr">
              <div class="td">被告/被上诉人/再审被申请人/被申请人/被告人</div>
              <div class="td">
                <p v-for="(item, index11) in sfinfoobj.defendant_list" :key="index11">{{ item }}</p>
              </div>
            </div>
            <div class="tr">
              <div class="td">开庭时间</div>
              <div class="td">{{ sfinfoobj.hold_date }}</div>
            </div>
            <div class="tr">
              <div class="td">结束时间</div>
              <div class="td">{{ sfinfoobj.finish_date }}</div>
            </div>
            <div class="tr">
              <div class="td">法院</div>
              <div class="td">{{ sfinfoobj.court }}</div>
            </div>
            <div class="tr">
              <div class="td">案例类型</div>
              <div class="td">{{ sfinfoobj.case_type }}</div>
            </div>
            <div class="tr">
              <div class="td">案例状态</div>
              <div class="td">{{ sfinfoobj.case_status }}</div>
            </div>
          </div>
          <div v-if="title == '当前欠税'" class="main">
            <div class="subtable-thead" style="background-color: rgb(249, 250, 255);">
              <div class="thead-item" style="flex: 1 1 0%;">
                <p>征收项目</p>
              </div>
              <div class="thead-item" style="flex: 1 1 0%;">
                <p>所属时期起</p>
              </div>
              <div class="thead-item" style="flex: 1 1 0%;">
                <p>所属时期止</p>
              </div>
              <div class="thead-item" style="flex: 1 1 0%;">
                <p>应补税额</p>
              </div>
              <div class="thead-item" style="flex: 1 1 0%;">
                <p>缴款期限</p>
              </div>
            </div>
            <div v-for="(item, index21) in qsarr" :key="index21" class="subtable-content-item"
              style="background-color: rgb(255, 255, 255);">
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.levy_project_name }}</p>
              </div>
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.begin_date }}</p>
              </div>
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.end_date }}</p>
              </div>
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.supplement_tax_amount }}</p>
              </div>
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.payment_limit_date }}</p>
              </div>
            </div>
          </div>
          <div v-if="title == '滞纳金'" class="main">
            <div class="subtable-thead" style="background-color: rgb(249, 250, 255);">
              <div class="thead-item" style="flex: 1 1 0%;">
                <p> 滞纳金时间</p>
              </div>
              <div class="thead-item" style="flex: 1 1 0%;">
                <p>滞纳金金额</p>
              </div>
            </div>
            <div v-for="(item, index21) in znjarr" :key="index21" class="subtable-content-item"
              style="background-color: rgb(255, 255, 255);">
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.tax_time }}</p>
              </div>
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.tax_paid }}</p>
              </div>

            </div>
          </div>
          <div v-if="title == '税务处罚'" class="main">
            <div class="subtable-thead" style="background-color: rgb(255, 255, 255);">
              <div class="thead-item" style="flex: 1 1 0%;">
                <p>日期</p>
              </div>
              <div class="thead-item" style="flex: 1 1 0%;">
                <p>违法违章信息</p>
              </div>
              <div class="thead-item" style="flex: 1 1 0%;">
                <p>违法违章状态</p>
              </div>
              <div class="thead-item download-ignore" style="flex: 1 1 0%;">
                <p>操作</p>
              </div>
            </div>
            <div v-for="(item, index22) in swarr" :key="index22" class="subtable-content-item"
              style="background-color: rgb(249, 250, 255);">
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.lian_date }}</p>
              </div>
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.info }}</p>
              </div>
              <div class="subtable-info-item" style="flex: 1 1 0%;">
                <p class="main-info van-multi-ellipsis--l3">{{ item.status }}</p>
              </div>
              <div class="subtable-info-item download-ignore" style="flex: 1 1 0%;">
                <p class="info-btn" @click="showinfos(item)" style="color: #196dff;">详情</p>
              </div>
            </div>
          </div>

          <div v-if="title == '变更详情'" class="table table-body">
            <div class="tr">
              <div class="td">变更类型</div>
              <div class="td">{{ bginfo.project_name }}</div>
            </div>
            <div class="tr">
              <div class="td">变更时间</div>
              <div class="td">{{ bginfo.change_date }}</div>
            </div>
            <div class="tr">
              <div class="td">变更前</div>
              <div class="td">
                <p class="main-info " v-for="(item, index9112) in bginfo.before_info" :key="index9112">{{ item }}</p>
              </div>
            </div>
            <div class="tr">
              <div class="td">变更后</div>
              <div class="td">
                <p class="main-info" v-for="(item, index9111) in bginfo.after_info" :key="index9111">
                  {{ item }}</p>

              </div>
            </div>
          </div>
          <div style="padding: 10px;"></div>
        </div>
      </div>

    </van-dialog>
    <van-dialog :closeOnClickOverlay="true" :showConfirmButton="false" v-model="colesshowinfo">
      <div class="table-dialog-content">

        <div class="table-header clear"><img @click="colesshowinfo = false" class="close-dialog-btn"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAB0ElEQVRYR73Yv0oDQRAG8G9SnoUWNgd5BAVBwdI/pLUWW2tbSztrn0Kwt42IWFqIoJI3uATExCJNwsrIHme4XG5vd/buNmXCXn75dnZ2CA2HwwsiugbwopQ663a73wj4mkwmG7PZ7BbALoArGo1GUwBrmeFNKdULhcowfQB72fdPNUi/0cuFEgRVggERPVOSJJudTkejdkKhyjAAPpj5mDQiJKoKE8fxVwoKhbJhtGMBahvlglkBtYVyxZSCmkZJMEZQUygpphJUF+WDsYJ8Ub4YJ5AUVQfjDHJFjcfj9fl8/pC7m/TStAPrpudyZy/1IduCqo4eRZGqixElZOno7wB+C/ehKJn/54sSsqDyAXthvBIqoB4BbBe2esDMB641UywTr4T0Q7ICfipsU1rESqlD3yHPC2Q4Tfkf6z3kiUEGzCAr6q2cygslAlX1GWbmJiZPZ5BL02ti8nQCuWAsLcF5+6wgCaYJVCXIB1MXZQTVwdRBlYIMmE9mPpJ2YGmhr4CaxPgktQRqAyNFLUBtYiSoFBQC44qikBgXlP475h7ASe5S9DpNtvG3+Lnh9PU1KAEQZwuCYCqS+tGgcwA3AF6Z+VTaZ6TJGJK6A7BPRJd/7NOPSvRfo2sAAAAASUVORK5CYII="
            alt="关闭">
          <p class="table-title">税务处罚详情</p>
        </div>
        <div class="dialog-scroll-box">
          <div class="table table-body">
            <div class="tr">
              <div class="td">立案日期</div>
              <div class="td">{{ showinfoobj.lian_date }}</div>
            </div>
            <div class="tr">
              <div class="td">违法违章状态</div>
              <div class="td">{{ showinfoobj.info }}</div>
            </div>
            <div class="tr">
              <div class="td">违法违章信息</div>
              <div class="td">{{ showinfoobj.status }}</div>
            </div>
            <div class="tr">
              <div class="td">违法违章事实</div>
              <div class="td">
                {{ showinfoobj.detail }}
              </div>
            </div>
          </div>
          <div style="padding: 10px;"></div>
        </div>
      </div>

    </van-dialog>
    <van-popup v-model="mypopup" round position="bottom" :style="{ height: '50%' }">

      <van-picker @confirm="onConfirm" @cancel="onCancel" show-toolbar :columns="columns" />
    </van-popup>
    <div class="header">
      <div class="report-header-comp h375">
        <div style="top: 6.8vw;" class="content t168">
          <div style="border-bottom:none" class="base-info">
            <!-- 添加报告编号按钮 -->
            <div style="display: flex; justify-content: space-between;cursor: pointer;align-items: center;">
              <div style="text-align: right;font-size: 12px;padding-top:7px;font-weight: 400;">
                查询时间:{{
                  addTimeYmd }}</div>
              <div class="report-number-btn" @click.stop="copy1">
                <span>报告编号：{{ $route.query.taxReportCode }}</span>
                <img src="https://oss.yeroye.com/finMgrApplet/companyReport/copy-alt.png" />
              </div>
            </div>


            <p class="company-name">{{ gsinfo.company_name }}</p>
            <!-- <p class="max-amount">(预估可贷：{{ gsinfo.company_name }}万)</p> -->
          </div>
          <!-- <div class="match-info"><span>最近匹配时间：2023-07-10 14:45:04</span></div> -->

        </div>
      </div>
    </div>
    <div style="background: #0b0a2a;" class="bg-layer">
      <!-- <div class="bg-image"><img src="../../assets/imgs/bj.png" alt=""></div> -->
    </div>

    <div class="body top324" style="height: auto;top: 39.4vw;">
      <div class="analysis-title">
        <p>
          <svg class="icon" style="margin-right: 2.13333vw;font-size: 18px;" aria-hidden="true">
            <use xlink:href="#icon-shujufenxi"></use>
          </svg>
          <span>企业分析详情</span>
        <div @click.stop="getsharetype" class="sharebtn">转发报告</div>

        </p>
        <div class="credit-entrance download-ignore">
          <p></p>
        </div>
      </div>
      <div class="report-detail-container">
        <div class="header">
          <div class="report-countdown-comp download-ignore"></div>
        </div>
        <div class="bodys">

          <div class="menu-area download-ignore">

            <van-sticky>
              <div class="report-menu-comp">
                <div @click="scrollToPosition(0)" class="menu-item" :class="{ 'selected-menu-item': active == 0 }">
                  <p>企业信息</p>
                </div>
                <div @click="scrollToPosition(1)" class="menu-item" :class="{ 'selected-menu-item': active == 1 }">
                  <p>税务数据</p>
                </div>
                <div @click="scrollToPosition(2)" class="menu-item" :class="{ 'selected-menu-item': active == 2 }">
                  <p>发票数据</p>
                </div>
                <!-- <div @click="scrollToPosition(3)" class="menu-item" :class="{ 'selected-menu-item': active == 3 }">
                  <p>产品匹配</p>
                </div> -->
              </div>
            </van-sticky>


          </div>


          <div class="content-area ">
            <div class="interval"></div>
            <div class="base-info position-1 roll">
              <p class="info-title">
                <svg class="icon" style="margin-right: 2.13333vw;font-size: 18px;" aria-hidden="true">
                  <use xlink:href="#icon-jibenxinxi"></use>
                </svg>
                <span>基本信息</span>
              </p>
              <div class="custom-table-comp">

                <div class="van-cell van-cell--borderless">
                  <div class="van-cell__title"><span>企业名称</span></div>
                  <div class="van-cell__value"><span>{{ formatValue(gsinfo.company_name) }}</span></div>
                </div>
                <div class="van-cell van-cell--borderless">
                  <div class="van-cell__title"><span>成立日期</span></div>
                  <div class="van-cell__value"><span>{{ formatValue(gsinfo.start_date) }}</span></div>
                </div>
                <div class="van-cell van-cell--borderless">
                  <div class="van-cell__title"><span>统一信用代码</span></div>
                  <div class="van-cell__value"><span>{{ formatValue(gsinfo.taxpayer_id) }}</span></div>
                </div>
                <div class="van-cell van-cell--borderless">
                  <div class="van-cell__title"><span>行业分类</span></div>
                  <div class="van-cell__value"><span>{{ formatValue(gsinfo.industry_type) }}</span></div>
                </div>
                <div class="van-cell van-cell--borderless">
                  <div class="van-cell__title"><span>注册类型</span></div>
                  <div class="van-cell__value"><span>{{ formatValue(gsinfo.organization_type) }}</span></div>
                </div>
                <div class="van-cell van-cell--borderless">
                  <div class="van-cell__title"><span>注册区域</span></div>
                  <div class="van-cell__value"><span>{{ formatValue(gsinfo.register_address) }}</span></div>
                </div>
                <template v-if="fold1">

                  <div class="van-cell van-cell--borderless">
                    <div class="van-cell__title"><span>法人年龄(岁)</span></div>
                    <div class="van-cell__value"><span>{{ formatValue(gsinfo.legal_person_age) }}</span></div>
                  </div>
                  <div class="van-cell van-cell--borderless">
                    <div class="van-cell__title"><span>法人是否占股</span></div>
                    <div class="van-cell__value"><span>{{ gsinfo.sharepct_of_legalpers ? '是' : '---' }}</span></div>
                  </div>
                  <div class="van-cell van-cell--borderless">
                    <div class="van-cell__title"><span>法人股份占比(%)</span></div>
                    <div class="van-cell__value"><span>{{ formatValue(gsinfo.sharepct_of_legalpers) }}</span></div>
                  </div>
                  <div class="van-cell van-cell--borderless">
                    <div class="van-cell__title"><span>法人/股东变更</span></div>
                    <div class="van-cell__value"><span>{{ gsinfo.legal_person_gd_change &&
                      gsinfo.legal_person_gd_change.length ? '有变更' : '无变更' }}</span>
                    </div>
                  </div>
                  <div class="judicial-info" style="padding: 0;"
                    v-if="gsinfo.legal_person_gd_change && gsinfo.legal_person_gd_change.length">

                    <div class="subtable-thead">
                      <div class="thead-item" style="flex: 1 1 0%;">
                        <p>变更类型</p>
                      </div>
                      <div class="thead-item" style="flex: 1 1 0%;">
                        <p>变更时间</p>
                      </div>
                      <div class="thead-item" style="flex: 1 1 0%;">
                        <p>变更前</p>
                      </div>
                      <div class="thead-item" style="flex: 1 1 0%;">
                        <p>变更后</p>
                      </div>
                      <div class="thead-item download-ignore" style="flex: 1 1 0%;">
                        <p>操作</p>
                      </div>
                    </div>
                    <div class="subtable-content-item" v-for="(item, index15) in gsinfo.legal_person_gd_change"
                      :key="index15">
                      <div class="subtable-info-item" style="flex: 1 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3">{{ item.project_name }}</p>
                      </div>
                      <div class="subtable-info-item" style="flex: 1 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3">{{ item.change_date }}</p>
                      </div>
                      <div class="subtable-info-item" style="flex: 1 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3" v-for="(item, index911) in item.before_info"
                          :key="index911">{{ item }}</p>
                      </div>
                      <div class="subtable-info-item" style="flex: 1 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3" v-for="(item, index922) in item.after_info"
                          :key="index922">{{ item }}</p>

                      </div>
                      <div class="subtable-info-item download-ignore" style="flex: 1 1 0%;">
                        <p @click="showgsinfo(item, '变更详情')" class="info-bsfsfinfotn" style="color: #196dff;">详情</p>
                      </div>

                    </div>



                  </div>

                  <div class="van-cell van-cell--borderless">
                    <div class="van-cell__title"><span>信贷查询记录</span></div>
                    <div class="van-cell__value"><span>{{ gsinfo.bank_and_tax_interactive &&
                      gsinfo.bank_and_tax_interactive.length ? '有信贷查询记录' : '无信贷查询记录' }}</span>
                    </div>
                  </div>
                  <template v-if="gsinfo.bank_and_tax_interactive && gsinfo.bank_and_tax_interactive.length">
                    <div class="van-cell van-cell--borderless">
                      <div class="van-cell__title"><span>信贷查询记录</span></div>
                      <div class="van-cell__value"><span></span>
                      </div>
                    </div>

                    <div class="subtable-thead">
                      <div class="thead-item" style="flex: 1.5 1 0%;">
                        <p>银行名称</p>
                      </div>
                      <div class="thead-item" style="flex: 1.5 1 0%;">
                        <p>申请时间</p>
                      </div>
                      <div class="thead-item" style="flex: 1 1 0%;">
                        <p>状态</p>
                      </div>
                    </div>
                    <div v-for="(item, index1) in gsinfo.bank_and_tax_interactive" :key="index1"
                      class="subtable-content-item">
                      <div class="subtable-info-item" style="flex: 1.5 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3">{{ item.bank_name }}</p>
                      </div>
                      <div class="subtable-info-item" style="flex: 1.5 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3">{{ item.declaration_date }}</p>
                      </div>
                      <div class="subtable-info-item" style="flex: 1 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3">{{ item.status }}</p>
                      </div>
                    </div>
                  </template>
                  <template v-if="gsinfo.shares_ratio_list && gsinfo.shares_ratio_list.length">
                    <div class="van-cell van-cell--borderless">
                      <div class="van-cell__title"><span>股东明细</span></div>
                      <div class="van-cell__value"><span> </span></div>
                    </div>
                    <div class="subtable-thead">
                      <div class="thead-item" style="flex: 1.5 1 0%;">
                        <p>股东名称</p>
                      </div>
                      <div class="thead-item" style="flex: 1.5 1 0%;">
                        <p>参股数额(元)</p>
                      </div>
                      <div class="thead-item" style="flex: 1 1 0%;">
                        <p>参股比例(%)</p>
                      </div>
                    </div>
                    <div class="subtable-content-item" v-for="(item, index2) in gsinfo.shares_ratio_list" :key="index2">
                      <div class="subtable-info-item" style="flex: 1.5 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3">{{ item.shareholder_name }}</p>
                      </div>
                      <div class="subtable-info-item" style="flex: 1.5 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3">{{ item.shares_amount }}</p>
                      </div>
                      <div class="subtable-info-item" style="flex: 1 1 0%;">
                        <p class="main-info van-multi-ellipsis--l3">{{ item.shares_rate }}</p>
                      </div>
                    </div>
                  </template>


                </template>
                <div @click="fold1 = !fold1" class="more download-ignore"><span>{{ fold1 ? '收起' : '展开' }}</span><i
                    class="van-badge__wrapper van-icon "
                    :class="[fold1 ? 'van-icon-arrow-up' : 'van-icon-arrow-down']"></i>
                </div>
              </div>
            </div>
            <div v-if="dtinfo.multipoint_info" class="interval"></div>
            <div v-if="dtinfo.multipoint_info" class="base-info position-1 mInfo">
              <p class="info-title"><img
                  src="data:image/png;base64,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"
                  alt=""><span>多头统计</span></p><span class="multiPoint_wrap">该数据仅供参考</span>
              <div class="bulls-info">

                <div class="subtable-thead">
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>时间统计</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>授权总次数</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>授权成功数</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>授权机构数</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>银行授权机构数</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>非银行授权机构数</p>
                  </div>
                </div>
                <div v-for="(item, index231) in dtinfo.multipoint_info" :key="index231" class="subtable-content-item">
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info van-multi-ellipsis--l3">{{ item.timeLimit }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info van-multi-ellipsis--l3">{{ item.authorizeTotalCount }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info van-multi-ellipsis--l3">{{ item.authorizeCount }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info van-multi-ellipsis--l3">{{ item.authorizeOrgCount }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info van-multi-ellipsis--l3">{{ item.bankAuthorizeOrgCount }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info van-multi-ellipsis--l3">{{ item.nonBankAuthorizeOrgCount }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="interval"></div>
            <div v-if="sfsfinfo.case_filing" class="base-info position-1 tInfo">
              <p class="info-title">

                <svg class="icon" style="margin-right: 2.13333vw;font-size: 18px;" aria-hidden="true">
                  <use xlink:href="#icon-a-zu17644"></use>
                </svg>
                <span>三方司法信息</span>
              </p>
              <div class="judicial-info" v-if="sfsfinfo.case_filing && sfsfinfo.case_filing.length">

                <div class="count"> 目前有 <span>{{ sfsfinfo.case_filing.length }}</span> 条立案信息 </div>
                <div class="subtable-thead">
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>立案日期</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>原告/上诉人/再审申请人/申请人/公诉人</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>被告/被上诉人/再审被申请人/被申请人/被告人</p>
                  </div>
                  <div class="thead-item download-ignore" style="flex: 1 1 0%;">
                    <p>操作</p>
                  </div>
                </div>
                <div class="subtable-content-item" v-for="(item, index5) in case_filing" :key="index5">
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info van-multi-ellipsis--l3">{{ item.publish_date }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info van-multi-ellipsis--l3" v-for="(item, index91) in item.prosecutor_list"
                      :key="index91">{{
                        item }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info van-multi-ellipsis--l3" v-for="(item, index92) in item.defendant_list"
                      :key="index92">{{
                        item }}</p>

                  </div>
                  <div class="subtable-info-item download-ignore" style="flex: 1 1 0%;">
                    <p @click="showgsinfo(item, '立案详情')" class="info-bsfsfinfotn" style="color: #196dff;">详情</p>
                  </div>

                </div>

                <div @click="fold9 = !fold9" class="more download-ignore"><span>{{ fold9 ? '收起' : '展开' }}</span><i
                    class="van-badge__wrapper van-icon "
                    :class="[fold9 ? 'van-icon-arrow-up' : 'van-icon-arrow-down']"></i>
                </div>

              </div>
              <div v-else class="empty-info">暂无数据</div>
            </div>

            <div class="interval"></div>
            <div class=" position-2 roll">

              <p class="info-title">
                <svg class="icon" style="margin-right: 2.13333vw;font-size: 18px;" aria-hidden="true">
                  <use xlink:href="#icon-nashui"></use>
                </svg>
                <span>纳税信息</span>
              </p>
              <div class="tax-info">

                <div class="info-item" style="width: 50%;"><span class="label">纳税信用等级</span><span class="value">{{
                  formatValue(swinfo.credit_level_prevyr) == '暂无' ? formatValue(swinfo.credit_level) :
                    formatValue(swinfo.credit_level_prevyr) }}
                  </span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">纳税人种类</span><span class="value">{{
                  formatValue(swinfo.nsrlx) }}
                  </span>
                  <div class="line"></div>
                </div>
                <div v-if="swinfo.cnt_of_hist_taxarrearcase" class="info-item" style="width: 50%;"><span
                    class="label">历史有无欠税记录</span><span class="value">{{
                      swinfo.cnt_of_hist_taxarrearcase ? '有欠税' : '无欠税' }}
                  </span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">近12个月纳税销售额(元)</span><span
                    class="value">{{
                      formatValue(swinfo.tax_ppev12mths_vat_sales, 2) }}</span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">近24个月纳税销售额(元)</span><span
                    class="value">{{
                      formatValue(swinfo.tax_ppev24mths_sale_all, 2) }}</span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">近12个月增值税应纳税额(元)</span><span
                    class="value">{{
                      formatValue(swinfo.tax_prev12mths_vat_payable) }}</span>
                  <div class="line"></div>
                </div>

                <div class="info-item" style="width: 50%;"><span class="label">近12个月纳税总额(元)</span><span class="value">{{
                  formatValue(swinfo.tax_ppev12mths_tax_paid) }}</span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">近12个月企业所得税已缴税额(元)</span><span
                    class="value">{{
                      formatValue(swinfo.las_12m_cit_tax_paid) }}</span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">近24个月纳税总额(元)</span><span class="value">{{
                  formatValue(swinfo.tax_ppev24mths_tax_paid) }}</span>
                  <div class="line"></div>
                </div>
                <template v-if="taxAccountingData">
                  <div class="info-item" style="width: 50%;">
                    <span class="label">纳税申报利润(元)</span>
                    <template
                      v-if="taxAccountingData.taxDeclarationProfitTwoAmount || taxAccountingData.taxDeclarationProfitOneAmount || taxAccountingData.taxDeclarationProfitThisAmount">

                      <span class="value valuestyle" v-if="taxAccountingData.taxDeclarationProfitTwoAmount">{{
                        taxAccountingData.taxDeclarationProfitTwoYear }}年度 {{
                          taxAccountingData.taxDeclarationProfitTwoAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.taxDeclarationProfitOneAmount">{{
                        taxAccountingData.taxDeclarationProfitOneYear }}年度 {{
                          taxAccountingData.taxDeclarationProfitOneAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.taxDeclarationProfitThisAmount">{{
                        taxAccountingData.taxDeclarationProfitThisYear }}年{{
                          taxAccountingData.taxDeclarationProfitThisYearMonthName }} {{
                          taxAccountingData.taxDeclarationProfitThisAmount }}</span>
                    </template>
                    <span class="value valuestyle" v-else>--</span>

                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;">
                    <span class="label">纳税申报收入(元)</span>

                    <template
                      v-if="taxAccountingData.taxDeclarationIncomeTwoAmount || taxAccountingData.taxDeclarationIncomeOneAmount || taxAccountingData.taxDeclarationIncomeThisAmount">
                      <span class="value valuestyle" v-if="taxAccountingData.taxDeclarationIncomeTwoAmount">{{
                        taxAccountingData.taxDeclarationIncomeTwoYear }}年度 {{
                          taxAccountingData.taxDeclarationIncomeTwoAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.taxDeclarationIncomeOneAmount">{{
                        taxAccountingData.taxDeclarationIncomeOneYear }}年度 {{
                          taxAccountingData.taxDeclarationIncomeOneAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.taxDeclarationIncomeThisAmount">{{
                        taxAccountingData.taxDeclarationIncomeThisYear }}年{{
                          taxAccountingData.taxDeclarationIncomeThisYearMonthName }} {{
                          taxAccountingData.taxDeclarationIncomeThisAmount }}</span>
                    </template>
                    <span class="value valuestyle" v-else>--</span>


                    <div class="line"></div>
                  </div>

                  <div class="info-item" style="width: 50%;">
                    <span class="label"> 增值税(元)</span>
                    <template
                      v-if="taxAccountingData.taxAddedTwoAmount || taxAccountingData.taxAddedOneAmount || taxAccountingData.taxAddedThisAmount">

                      <span class="value valuestyle" v-if="taxAccountingData.taxAddedTwoAmount">{{
                        taxAccountingData.taxAddedTwoYear }}年度 {{
                          taxAccountingData.taxAddedTwoAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.taxAddedOneAmount">{{
                        taxAccountingData.taxAddedOneYear }}年度 {{
                          taxAccountingData.taxAddedOneAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.taxAddedThisAmount">{{
                        taxAccountingData.taxAddedThisYear }}年{{
                          taxAccountingData.taxAddedThisYearMonthName }} {{
                          taxAccountingData.taxAddedThisAmount }}</span>
                    </template>
                    <span class="value valuestyle" v-else>--</span>

                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;">
                    <span class="label">所得税(元)</span>
                    <template
                      v-if="taxAccountingData.taxIncomeTwoAmount || taxAccountingData.taxIncomeOneAmount || taxAccountingData.taxIncomeThisAmount">

                      <span class="value valuestyle" v-if="taxAccountingData.taxIncomeTwoAmount">{{
                        taxAccountingData.taxIncomeTwoYear }}年度 {{
                          taxAccountingData.taxIncomeTwoAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.taxIncomeOneAmount">{{
                        taxAccountingData.taxIncomeOneYear }}年度 {{
                          taxAccountingData.taxIncomeOneAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.taxIncomeThisAmount">{{
                        taxAccountingData.taxIncomeThisYear }}年{{
                          taxAccountingData.taxIncomeThisYearMonthName }} {{
                          taxAccountingData.taxIncomeThisAmount }}</span>
                    </template>
                    <span class="value valuestyle" v-else>--</span>

                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;">
                    <span class="label">纳税总额(元)</span>
                    <template
                      v-if="taxAccountingData.totalTaxPaymentTwoAmount || taxAccountingData.totalTaxPaymentOneAmount || taxAccountingData.totalTaxPaymentThisAmount">

                      <span class="value valuestyle" v-if="taxAccountingData.totalTaxPaymentTwoAmount">{{
                        taxAccountingData.totalTaxPaymentTwoYear }}年度 {{
                          taxAccountingData.totalTaxPaymentTwoAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.totalTaxPaymentOneAmount">{{
                        taxAccountingData.totalTaxPaymentOneYear }}年度 {{
                          taxAccountingData.totalTaxPaymentOneAmount }}</span>
                      <span class="value valuestyle" v-if="taxAccountingData.totalTaxPaymentThisAmount">{{
                        taxAccountingData.totalTaxPaymentThisYear }}年{{
                          taxAccountingData.totalTaxPaymentThisYearMonthName }} {{
                          taxAccountingData.totalTaxPaymentThisAmount }}</span>
                    </template>
                    <span class="value valuestyle" v-else>--</span>
                    <div class="line"></div>
                  </div>
                </template>
                <template v-if="fold2">

                  <div class="info-item" style="width: 100%;"><span class="label">近2年资产负债率的增长率（纳税）(%)</span><span
                      class="value">{{ formatValue(swinfo.tax_2ytd_debt_to_asset_growth_pct, 2) }}</span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">借款与股东权益占比(%)</span><span
                      class="value">{{
                        formatValue(swinfo.tax_borrowing_to_equity_pct, 2) }}</span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">是否有连续6个月以上0申报</span><span
                      class="value">{{ swinfo.any_prev6mnths_zerotax == '1' ? '是' : '否' }}</span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">是否有连续10个月以上0申报</span><span
                      class="value">{{ swinfo.any_more_than_cntns_10mths_zerotax == '1' ? '是' : '否' }}</span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近12月0申报月数(月)</span><span
                      class="value">{{
                        formatValue(swinfo.tax_prev12mths_mths_zerodec) }}</span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近12月连续0申报月数(月)</span><span
                      class="value">{{ formatValue(swinfo.cont_zero_dec_mons) }}</span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">滞纳金记录</span><span class="value">{{
                    swinfo.overdue_fine && swinfo.overdue_fine.length ? '有' : '无' }}<span
                        @click="showgsinfo(swinfo.overdue_fine, '滞纳金')"
                        v-if="swinfo.overdue_fine && swinfo.overdue_fine.length" class="detail download-ignore">
                        详情 <i class="van-badge__wrapper van-icon van-icon-arrow"></i></span>
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">税务处罚</span><span class="value">{{
                    swinfo.tax_penalty && swinfo.tax_penalty.length ? '有' : '无' }}<span
                        @click="showgsinfo(swinfo.tax_penalty, '税务处罚')"
                        v-if="swinfo.tax_penalty && swinfo.tax_penalty.length" class="detail download-ignore">
                        详情 <i class="van-badge__wrapper van-icon van-icon-arrow"></i></span>
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">当前欠税</span><span class="value">{{
                    swinfo.cur_owing_taxes_detail && swinfo.cur_owing_taxes_detail.length ? '有' : '无' }}<span
                        class="detail download-ignore" @click="showgsinfo(swinfo.cur_owing_taxes_detail, '当前欠税')"
                        v-if="swinfo.cur_owing_taxes_detail && swinfo.cur_owing_taxes_detail.length"> 详情 <i
                          class="van-badge__wrapper van-icon van-icon-arrow"></i></span>
                    </span>
                    <div class="line"></div>
                  </div>

                </template>

                <div style="width: 100%;">
                  <div @click="fold2 = !fold2" class="more download-ignore"><span>{{ fold2 ? '收起' :
                    '展开' }}</span><i class="van-badge__wrapper van-icon "
                      :class="[fold2 ? 'van-icon-arrow-up' : 'van-icon-arrow-down']"></i>
                  </div>
                </div>

                <div class="footer"></div>
              </div>
            </div>
            <div class="position-2 tax" v-if="swinfo.near_3years_tax_amount && swinfo.near_3years_tax_amount.length">
              <div class="sales-info-comp">
                <div class="title-three">
                  <div class="left"><span>近三年已缴税额</span></div>
                  <div class="right">
                    <div class="year-item"><span class="block"></span><span>{{
                      swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length - 1].year
                        }}</span></div>
                    <div class="year-item"><span class="block"></span><span>{{
                      swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length - 1].year - 1
                        }}</span></div>
                    <div class="year-item"><span class="block"></span><span>{{
                      swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length - 1].year - 2
                        }}</span></div>
                  </div>
                </div>
                <div id="mainss"></div>
                <div class="empty-info" style="display: none;">暂无数据</div>
              </div>
              <div class="data-table-comp data-table-money_count-1688974374337">

                <table v-if="swinfo.near_3years_tax_amount1 && swinfo.near_3years_tax_amount1.length"
                  style="width: 100%;" border="0" cellpadding="0" cellspacing="0">
                  <thead>
                    <tr>
                      <th>
                        <div>月份</div>
                      </th>
                      <th>
                        <div>{{ swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length - 1].year
                        }}
                        </div>
                      </th>
                      <th>
                        <div>{{ swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length - 1].year
                          -
                          1
                        }}</div>
                      </th>
                      <th>
                        <div>{{ swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length - 1].year
                          -
                          2
                        }}</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="cnear_3years_tax_amount">
                    <tr v-for="(item, index2) in cnear_3years_tax_amount" :key="index2">
                      <td>
                        <div>{{ item.month }}月</div>
                      </td>
                      <td>
                        <div>{{ item.money_count[2] }}</div>
                      </td>
                      <td>
                        <div>{{ item.money_count[1] }}</div>
                      </td>
                      <td>
                        <div>{{ item.money_count[0] }}</div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-if="fold3">
                    <tr>
                      <td>
                        <div>合计</div>
                      </td>
                      <td>
                        <div>{{
                          !isNaN(swinfo.near_3years_tax_amountresult[swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length
                            - 1].year] / 100) ?
                            (swinfo.near_3years_tax_amountresult[swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length
                              - 1].year] / 100) : '' }}</div>
                      </td>
                      <td>
                        <div>
                          {{
                            !isNaN(swinfo.near_3years_tax_amountresult[swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length
                              - 1].year - 1] / 100) ?
                              (swinfo.near_3years_tax_amountresult[swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length
                                - 1].year - 1] / 100) : '' }}</div>
                      </td>
                      <td>
                        <div>
                          {{
                            !isNaN(swinfo.near_3years_tax_amountresult[swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length
                              - 1].year - 2] / 100) ?
                              (swinfo.near_3years_tax_amountresult[swinfo.near_3years_tax_amount[swinfo.near_3years_tax_amount.length
                                - 1].year - 2] / 100) : '' }}</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>


                <div @click="fold3 = !fold3" class="more download-ignore"><span>{{ fold3 ? '收起全部月份' : '展开全部月份'
                }}</span><i class="van-badge__wrapper van-icon "
                    :class="[fold3 ? 'van-icon-arrow-up' : 'van-icon-arrow-down']"></i>
                </div>
              </div>
            </div>

            <div class="interval"></div>
            <div class="ticket-info position-3 roll">
              <p class="info-title">
                <svg class="icon" style="margin-right: 2.13333vw;font-size: 18px;" aria-hidden="true">
                  <use xlink:href="#icon-icon-test"></use>
                </svg>
                <span>销售对比分析</span>
              </p>
              <div class="tax-info">
                <!-- <div class="bg-top"><img
                    src="https://static.wfq2020.com/wfzx-enterprise/3399/static/img/tax-bg1.053c2f59.png" alt=""></div>
                <div class="bg-bottom"><img
                    src="https://static.wfq2020.com/wfzx-enterprise/3399/static/img/tax-bg2.4dedc18c.png" alt=""></div> -->
                <div class="info-item" style="width: 50%;"><span class="label">近12个月下游客户数量(家)</span><span
                    class="value">{{
                      formatValue(fpinfo.fp_prev12mths_qty_of_clnt) }}
                  </span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">最早开票时长(月)</span><span class="value">{{
                  formatValue(fpinfo.fp_minbilldttd_tmspan, 1) }}
                  </span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">近45日是否有开票记录</span><span class="value">{{
                  fpinfo.any_pre45days_fp_rcd == '1' ? '是' : '否' }}
                  </span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">近12个月是否断票</span><span class="value">{{
                  fpinfo.has_broken_fp_last12mths == '1' ? '是' : '否' }}
                  </span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 100%;"><span class="label">近12个月最大连续未开票间隔天数(销项)</span><span
                    class="value">{{
                      formatValue(fpinfo.fp_prev12mths_maxcon_day_noinvoice) }}</span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">近12个月断票月数(月)</span><span class="value">{{
                  formatValue(fpinfo.fp_prev12mths_mths_wo_fp) }}
                  </span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">历史断票月数(月)</span><span class="value">{{
                  formatValue(fpinfo.stop_inv_mons_hist) }}
                  </span>
                  <div class="line"></div>
                </div>
                <div class="info-item" style="width: 50%;"><span class="label">历史连续断票月数(月)</span><span class="value">{{
                  formatValue(fpinfo.cntns_0fp_mths) }}
                  </span>
                  <div class="line"></div>
                </div>
                <template v-if="fold4">
                  <div class="info-item" style="width: 100%;"><span class="label">近12个月(含2月份)最长连续断票月数(月)</span><span
                      class="value">{{ formatValue(fpinfo.fp_prev12mths_max_mthsinseries_wo_fp) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 100%;"><span class="label">近12个月(不含2月份)最长连续断票月数(月)</span><span
                      class="value">{{ formatValue(fpinfo.fp_prev12mths_max_mthsinseries_wo_fp_excl_chnnymth) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近12个月作废发票张数占比(%)</span><span
                      class="value">{{ formatValue(fpinfo.fp_void_info[2].quantity_count_rate, 2) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近12个月红冲发票金额占比(%)</span><span
                      class="value">{{ formatValue(fpinfo.fp_red_ink_info[2].money_count_rate, 2) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">冲正票比例(%)</span><span class="value">{{
                    formatValue(fpinfo.pct_of_pstv_ticket) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">离散度</span><span class="value">{{
                    formatValue(fpinfo.fp_prev12mths_avgamt_stdev) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近30天开票金额(元)</span><span
                      class="value">{{
                        formatValue(fpinfo.fp_pre30days_tot_amt) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近1个月开票金额(元)</span><span
                      class="value">{{
                        formatValue(fpinfo.fp_prev1mths_tot_amt) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近3个月开票金额(元)</span><span
                      class="value">{{
                        formatValue(fpinfo.fp_prev3mths_tot_amt) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近6个月开票金额(元)</span><span
                      class="value">{{
                        formatValue(fpinfo.fp_prev6mths_tot_amt) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近12个月开票金额(元)</span><span
                      class="value">{{
                        formatValue(fpinfo.fp_prev12mths_tot_amt) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近24个月开票金额(元)</span><span
                      class="value">{{
                        formatValue(fpinfo.fp_prev24mths_tot_amt) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近6个月开票金额环比增长率(%)</span><span
                      class="value">{{ formatValue(fpinfo.fp_prev6mths_avgamt_qoq_growthrt) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近9个月开票金额环比增长率(%)</span><span
                      class="value">{{ formatValue(fpinfo.fp_prev9mths_amt_qoq_growthrt) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 50%;"><span class="label">近12个月开票金额环比增长率(%)</span><span
                      class="value">{{ formatValue(fpinfo.fp_prev12mths_amt_qoq_growthrt) }}
                    </span>
                    <div class="line"></div>
                  </div>
                  <div class="info-item" style="width: 100%;"><span class="label">近12个月月均开票金额同比增长率(%)</span><span
                      class="value">{{ formatValue(fpinfo.fp_prev12mths_avgamt_pop_growthrt_excl_affmth, 2) }}
                    </span>
                    <div class="line"></div>
                  </div>
                </template>

                <div style="width: 100%;">
                  <div @click="fold4 = !fold4" class="more download-ignore"><span>{{ fold4 ? '收起' :
                    '展开'
                      }}</span><i class="van-badge__wrapper van-icon "
                      :class="[fold4 ? 'van-icon-arrow-up' : 'van-icon-arrow-down']"></i>
                  </div>
                </div>
                <div class="footer"></div>
              </div>
            </div>
            <div class="ticket-info position-3 ia"></div>
            <div class="ticket-info position-3"
              v-if="fpinfo.near_3years_invoiceresult && fpinfo.near_3years_invoice.length">
              <div class="sales-info-comp">
                <div class="title-one">
                  <div class="left"><span>近三年销售信息</span></div>
                  <div class="right">
                    <div class="picker" @click="mypopup = true"><span class="name">{{ columns[columnsindex]
                    }}</span><img class="icon-down download-ignore"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAALCAYAAACd1bY6AAAA/klEQVQokZXSzytEYRTG8c9cTFnZ+oOEkDKhlIWUZCPFalaUmiULFlcW8iM2NnaSlY0FJbH0F8gCJSnG4n2vpmnuzTzbc57ve8553lKapj14wB0m8Kk9LWEdlQQ/SDCCU5TbAC1iA92oJ3hHP54xhBN0/QM0h03UMY+LJBYe0YcXjOEQHQWgGaQN0+0S1st0jwG8YhJ7OcCpaC5hGVtZIWlqvMUg3jCNnWjKNI6D+EhVuNefmmFwLYTxgVlsR+AojiJoDbVmY2cLGFxF8xkW0IthIekaVluZWk2W6RIVfAmhlIW1qnmGIhicC8l9Yx8rRc15azbqGE+4ET54rn4BeHQx4RiFrbQAAAAASUVORK5CYII=">
                    </div>
                  </div>
                </div>
                <div class="title-two">
                  <div class="left">
                    <div class="top"><span>{{ columnsindex == 1 ? '总票（张）' : '总额（元）：' }}{{ (
                      fpinfo.near_3years_invoiceresult[fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length -
                        1].year][columnszd[columnsindex]] +
                      fpinfo.near_3years_invoiceresult[fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length -
                        1].year - 1][columnszd[columnsindex]] +
                      fpinfo.near_3years_invoiceresult[fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length -
                        1].year - 2][columnszd[columnsindex]]) / 100 }}</span></div>
                  </div>
                  <div class="right">
                    <div class="year-item"><span class="block"></span><span>{{
                      fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length -
                        1].year }}</span></div>
                    <div class="year-item"><span class="block"></span><span>{{
                      fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length -
                        1].year - 1 }}</span></div>
                    <div class="year-item"><span class="block"></span><span>{{
                      fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length -
                        1].year - 2 }}</span></div>
                  </div>
                </div>
                <div id="mainss1"></div>

                <div class="empty-info" style="display: none;">暂无数据</div>
              </div>
              <div style="overflow: hidden;" v-if="fpinfo.near_3years_invoice && fpinfo.near_3years_invoice.length"
                class="data-table-comp data-table-money_count-quantity_count-hcfp_amt-invldfp_amt-1688974374315">
                <div class="title">{{ columns[columnsindex] }}</div>
                <table border="0" cellpadding="0" cellspacing="0">
                  <thead>
                    <tr>
                      <th>
                        <div>月份</div>
                      </th>
                      <th>
                        <div>{{ fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length - 1].year }}</div>
                      </th>
                      <th>
                        <div>{{ fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length - 1].year - 1 }}</div>
                      </th>
                      <th>
                        <div>{{ fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length - 1].year - 2 }}</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr v-for="(item, index3) in cnear_3years_invoice" :key="index3">
                      <template v-if="columnsindex == 0">
                        <td>
                          <div>{{ item.month }}月</div>
                        </td>
                        <td>
                          <div>{{ item.money_count[2] }}</div>
                        </td>
                        <td>
                          <div>{{ item.money_count[1] }}</div>
                        </td>
                        <td>
                          <div>{{ item.money_count[0] }}</div>
                        </td>
                      </template>
                      <template v-if="columnsindex == 1">
                        <td>
                          <div>{{ item.month }}月</div>
                        </td>
                        <td>
                          <div>{{ item.quantity_count[2] }}</div>
                        </td>
                        <td>
                          <div>{{ item.quantity_count[1] }}</div>
                        </td>
                        <td>
                          <div>{{ item.quantity_count[0] }}</div>
                        </td>
                      </template>
                      <template v-if="columnsindex == 2">
                        <td>
                          <div>{{ item.month }}月</div>
                        </td>
                        <td>
                          <div>{{ item.hcfp_amt[2] }}</div>
                        </td>
                        <td>
                          <div>{{ item.hcfp_amt[1] }}</div>
                        </td>
                        <td>
                          <div>{{ item.hcfp_amt[0] }}</div>
                        </td>
                      </template>
                      <template v-if="columnsindex == 3">
                        <td>
                          <div>{{ item.month }}月</div>
                        </td>
                        <td>
                          <div>{{ item.invldfp_amt[2] }}</div>
                        </td>
                        <td>
                          <div>{{ item.invldfp_amt[1] }}</div>
                        </td>
                        <td>
                          <div>{{ item.invldfp_amt[0] }}</div>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                  <tfoot v-if="fold5">
                    <tr>
                      <td>
                        <div>合计</div>
                      </td>
                      <td>
                        <div>{{
                          (fpinfo.near_3years_invoiceresult[fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length
                            -
                            1].year][columnszd[columnsindex]]) === '' ? '' :
                            (fpinfo.near_3years_invoiceresult[fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length
                              -
                              1].year][columnszd[columnsindex]] / 100) }}</div>
                      </td>
                      <td>
                        <div>{{
                          (fpinfo.near_3years_invoiceresult[fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length
                            -
                            1].year - 1][columnszd[columnsindex]]) === '' ? '' :
                            (fpinfo.near_3years_invoiceresult[fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length
                              -
                              1].year - 1][columnszd[columnsindex]] / 100) }}</div>
                      </td>
                      <td>
                        <div>{{
                          (fpinfo.near_3years_invoiceresult[fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length
                            -
                            1].year - 2][columnszd[columnsindex]]) === '' ? '' :
                            (fpinfo.near_3years_invoiceresult[fpinfo.near_3years_invoice[fpinfo.near_3years_invoice.length
                              -
                              1].year - 2][columnszd[columnsindex]] / 100) }}</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <div @click="fold5 = !fold5" class="more download-ignore"><span>{{ fold5 ? '收起全部月份' : '展开全部月份'
                }}</span><i class="van-badge__wrapper van-icon "
                    :class="[fold5 ? 'van-icon-arrow-up' : 'van-icon-arrow-down']"></i>
                </div>
              </div>
            </div>
            <div class="interval"></div>
            <div class="ticket-info position-3 cus">
              <p class="info-title">
                <svg class="icon" style="margin-right: 2.13333vw;font-size: 18px;" aria-hidden="true">
                  <use xlink:href="#icon-tubiaozhizuomoban"></use>
                </svg>
                <span>近一年前十大客户信息</span>
              </p>
              <div v-if="top10_customer_info.length" class="near-one-customer-info">
                <div class="subtable-thead">
                  <div class="thead-item">
                    <p>排名</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>客户名称</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>销售额(元)</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>金额占比(%)</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>是否关联方</p>
                  </div>
                </div>
                <div class="subtable-content-item" v-for="(item, index4) in top10_customer_info" :key="index4">
                  <div class="subtable-info-item">
                    <p class="main-info"><span class="parent"><span class="text">{{ index4 + 1 }}</span></span></p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info">{{ item.name }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info">{{ item.amount }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info" style="color: rgb(255, 163, 25);">{{ item.amt_proportion }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info">{{ item.tag }}</p>
                  </div>
                </div>

                <div @click="fold6 = !fold6" class="more download-ignore"><span>{{ fold6 ? '收起' : '展开'
                }}</span><i class="van-badge__wrapper van-icon "
                    :class="[fold6 ? 'van-icon-arrow-up' : 'van-icon-arrow-down']"></i>
                </div>
              </div>
              <div v-else class="empty-info">暂无数据</div>

            </div>
            <div class="interval"></div>
            <div class="ticket-info position-3 apply">
              <p class="info-title">
                <svg class="icon" style="margin-right: 2.13333vw;font-size: 18px;" aria-hidden="true">
                  <use xlink:href="#icon-tubiaozhizuomoban"></use>
                </svg>
                <span>近一年前十大供应商信息</span>
              </p>
              <div v-if="top10_supplier_info.length" class="near-one-customer-info">
                <div class="subtable-thead">
                  <div class="thead-item">
                    <p>排名</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>供应商名称</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>采购额(元)</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>金额占比(%)</p>
                  </div>
                  <div class="thead-item" style="flex: 1 1 0%;">
                    <p>是否关联方</p>
                  </div>
                </div>
                <div class="subtable-content-item" v-for="(item, index4) in top10_supplier_info" :key="index4">
                  <div class="subtable-info-item">
                    <p class="main-info"><span class="parent"><span class="text">{{ index4 + 1 }}</span></span></p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info">{{ item.name }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info">{{ item.amount }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info" style="color: rgb(255, 163, 25);">{{ item.amt_proportion }}</p>
                  </div>
                  <div class="subtable-info-item" style="flex: 1 1 0%;">
                    <p class="main-info">{{ item.tag }}</p>
                  </div>
                </div>


                <div @click="fold7 = !fold7" class="more download-ignore"><span>{{ fold7 ? '收起' : '展开'
                }}</span><i class="van-badge__wrapper van-icon "
                    :class="[fold7 ? 'van-icon-arrow-up' : 'van-icon-arrow-down']"></i>
                </div>
              </div>
              <div v-else class="empty-info">暂无数据</div>

            </div>

            <!-- <div class="interval"></div>
            <div class="product-info position-4 roll">
              <p class="product-analysis-title"><img
                  src=""
                  alt=""></p>
              <div class="product-analysis-list-comp product-fuhe">
                <div class="analysis-status-box">
                  <div class="judge-status-item judge-status-selected">
                    <p>符合</p>
                  </div>
                  <div class="judge-status-item download-ignore">
                    <p>不符</p>
                  </div>
                  <div class="judge-status-item download-ignore">
                    <p>未判断</p>
                  </div>
                </div>
                <div class="interval"></div>
                <div v-if="false" class="product-list">
                  <div class="product-analysis-item-comp">
                    <div class="header">
                      <div class="product-name">
                        <div><img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAzO32bPCTOtOkxpZcEXcYDgfP1Sjjs6CN+Nurm3ZjHwVGnqYcAAAAmElEQVQoz32R2Q6DIBBFAQuI1i4UBbvP//9kw5LAVPA83AdOJjkJZBdpqaYerQd3ye9mhQKVxRGgF4ql7fLJAbozIae0fCoE83dpObqQ12mMiwXw4QZxschggarYt1G1fhpVcLfO1Ko8olIVGHMVRtSqssBVpXijKo+L4rWpeoZvsrPv6SFugD0kIQvUmHeEUZr+oxdJWvwA1z4eMKkZZzAAAAAASUVORK5CYII="
                            alt="产品图标"></div>
                        <p class="elp">慧到账</p>
                      </div><span class="download-ignore"> 查看进件 <i
                          class="van-badge__wrapper van-icon van-icon-arrow"></i></span>
                    </div>
                    <div class="fbody download-ignore">
                      <div class="loan">
                        <p class="evaluate"><span class="label">预估额度(万)</span><span class="value">138</span></p>
                        <p class="loan-max" style="opacity: 1;"><span class="label">最高额度(万)</span><span
                            class="value">165</span></p>
                      </div>
                      <div class="interest-rate">
                        <div class="rate"><span class="label">利率</span><span class="value">2.0-10.0</span></div>
                        <div class="cycle"><span class="label">周期</span><span class="value">12个月</span></div>
                      </div>
                      <div class="repay-type"></div>
                    </div>
                  </div>
                  <div class="product-analysis-item-comp">
                    <div class="header">
                      <div class="product-name">
                        <div><img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAzO32bPCTOtOkxpZcEXcYDgfP1Sjjs6CN+Nurm3ZjHwVGnqYcAAAAmElEQVQoz32R2Q6DIBBFAQuI1i4UBbvP//9kw5LAVPA83AdOJjkJZBdpqaYerQd3ye9mhQKVxRGgF4ql7fLJAbozIae0fCoE83dpObqQ12mMiwXw4QZxschggarYt1G1fhpVcLfO1Ko8olIVGHMVRtSqssBVpXijKo+L4rWpeoZvsrPv6SFugD0kIQvUmHeEUZr+oxdJWvwA1z4eMKkZZzAAAAAASUVORK5CYII="
                            alt="产品图标"></div>
                        <p class="elp">慧到账</p>
                      </div><span class="download-ignore"> 查看进件 <i
                          class="van-badge__wrapper van-icon van-icon-arrow"></i></span>
                    </div>
                    <div class="fbody download-ignore">
                      <div class="loan">
                        <p class="evaluate"><span class="label">预估额度(万)</span><span class="value">138</span></p>
                        <p class="loan-max" style="opacity: 1;"><span class="label">最高额度(万)</span><span
                            class="value">165</span></p>
                      </div>
                      <div class="interest-rate">
                        <div class="rate"><span class="label">利率</span><span class="value">2.0-10.0</span></div>
                        <div class="cycle"><span class="label">周期</span><span class="value">12个月</span></div>
                      </div>
                      <div class="repay-type"></div>
                    </div>
                  </div>
                  <div class="product-analysis-item-comp">
                    <div class="header">
                      <div class="product-name">
                        <div><img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAzO32bPCTOtOkxpZcEXcYDgfP1Sjjs6CN+Nurm3ZjHwVGnqYcAAAAmElEQVQoz32R2Q6DIBBFAQuI1i4UBbvP//9kw5LAVPA83AdOJjkJZBdpqaYerQd3ye9mhQKVxRGgF4ql7fLJAbozIae0fCoE83dpObqQ12mMiwXw4QZxschggarYt1G1fhpVcLfO1Ko8olIVGHMVRtSqssBVpXijKo+L4rWpeoZvsrPv6SFugD0kIQvUmHeEUZr+oxdJWvwA1z4eMKkZZzAAAAAASUVORK5CYII="
                            alt="产品图标"></div>
                        <p class="elp">慧到账</p>
                      </div><span class="download-ignore"> 查看进件 <i
                          class="van-badge__wrapper van-icon van-icon-arrow"></i></span>
                    </div>
                    <div class="fbody download-ignore">
                      <div class="loan">
                        <p class="evaluate"><span class="label">预估额度(万)</span><span class="value">138</span></p>
                        <p class="loan-max" style="opacity: 1;"><span class="label">最高额度(万)</span><span
                            class="value">165</span></p>
                      </div>
                      <div class="interest-rate">
                        <div class="rate"><span class="label">利率</span><span class="value">2.0-10.0</span></div>
                        <div class="cycle"><span class="label">周期</span><span class="value">12个月</span></div>
                      </div>
                      <div class="repay-type"></div>
                    </div>
                  </div>
                  <div class="product-analysis-item-comp">
                    <div class="header">
                      <div class="product-name">
                        <div><img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAzO32bPCTOtOkxpZcEXcYDgfP1Sjjs6CN+Nurm3ZjHwVGnqYcAAAAmElEQVQoz32R2Q6DIBBFAQuI1i4UBbvP//9kw5LAVPA83AdOJjkJZBdpqaYerQd3ye9mhQKVxRGgF4ql7fLJAbozIae0fCoE83dpObqQ12mMiwXw4QZxschggarYt1G1fhpVcLfO1Ko8olIVGHMVRtSqssBVpXijKo+L4rWpeoZvsrPv6SFugD0kIQvUmHeEUZr+oxdJWvwA1z4eMKkZZzAAAAAASUVORK5CYII="
                            alt="产品图标"></div>
                        <p class="elp">慧到账</p>
                      </div><span class="download-ignore"> 查看进件 <i
                          class="van-badge__wrapper van-icon van-icon-arrow"></i></span>
                    </div>
                    <div class="fbody download-ignore">
                      <div class="loan">
                        <p class="evaluate"><span class="label">预估额度(万)</span><span class="value">138</span></p>
                        <p class="loan-max" style="opacity: 1;"><span class="label">最高额度(万)</span><span
                            class="value">165</span></p>
                      </div>
                      <div class="interest-rate">
                        <div class="rate"><span class="label">利率</span><span class="value">2.0-10.0</span></div>
                        <div class="cycle"><span class="label">周期</span><span class="value">12个月</span></div>
                      </div>
                      <div class="repay-type"></div>
                    </div>
                  </div>
                  <div class="product-analysis-item-comp">
                    <div class="header">
                      <div class="product-name">
                        <div><img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAzO32bPCTOtOkxpZcEXcYDgfP1Sjjs6CN+Nurm3ZjHwVGnqYcAAAAmElEQVQoz32R2Q6DIBBFAQuI1i4UBbvP//9kw5LAVPA83AdOJjkJZBdpqaYerQd3ye9mhQKVxRGgF4ql7fLJAbozIae0fCoE83dpObqQ12mMiwXw4QZxschggarYt1G1fhpVcLfO1Ko8olIVGHMVRtSqssBVpXijKo+L4rWpeoZvsrPv6SFugD0kIQvUmHeEUZr+oxdJWvwA1z4eMKkZZzAAAAAASUVORK5CYII="
                            alt="产品图标"></div>
                        <p class="elp">慧到账</p>
                      </div><span class="download-ignore"> 查看进件 <i
                          class="van-badge__wrapper van-icon van-icon-arrow"></i></span>
                    </div>
                    <div class="fbody download-ignore">
                      <div class="loan">
                        <p class="evaluate"><span class="label">预估额度(万)</span><span class="value">138</span></p>
                        <p class="loan-max" style="opacity: 1;"><span class="label">最高额度(万)</span><span
                            class="value">165</span></p>
                      </div>
                      <div class="interest-rate">
                        <div class="rate"><span class="label">利率</span><span class="value">2.0-10.0</span></div>
                        <div class="cycle"><span class="label">周期</span><span class="value">12个月</span></div>
                      </div>
                      <div class="repay-type"></div>
                    </div>
                  </div>
                </div>
                <div class="empty-info" v-else>暂无数据</div>
                <div class="next-page">
                  <p>下一页</p>
                </div> -->
          </div>
        </div>
      </div>
      <img style="width: 100%" v-if="!llqtype" src="../../assets/imgs/tg.png" alt="" srcset="">
      <div v-else style="position: relative;">
        <img style="width: 100%" src="https://oss.yeroye.com/finMgrApplet/tax/wap_app_gg.png" alt="" srcset="">
        <span @click="wxback" style="position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 120px;
    height: 30px;
    font-size: 24px;
    font-weight: 800;
    text-align: center;
    color: #fff;
    line-height: 30px;">开始制作</span>
      </div>
    </div>
    <div class="modal-overlay" v-if="friendShare" @click="friendShare = false">
      <img src="../../assets/imgs/share.png" alt="" style="position: fixed;width: 70%;top: 0;right: 0;">

    </div>

    <Toast ref="toast" />
    <Modal :visible.sync="showModal">
      <div class="btnbox">
        <div @click="copy">复制链接</div>
        <div @click="showModal = false; friendShare = true">分享给好友</div>
      </div>
    </Modal>

  </div>
  <div v-else style="height: 100%;padding-top: 200px;" class="empty-info">
    <div v-if="returnExtendData == 1"
      style="display: flex;justify-content: center;align-items: center;flex-direction: column;"> <img
        src="../../assets/imgs/s.png" alt="" srcset="" style="margin: 20px 0;width: 100px;">
      税票报告生成中，预计总耗时5至10分钟，请稍后查看！
    </div>
    <div v-else style="display: flex;justify-content: center;align-items: center;flex-direction: column;"> <img
        src="../../assets/imgs/k.png" alt="" srcset="" style="margin: 20px 0;width: 100px;">
      未找到对应的税票报告查询记录
    </div>



  </div>
</template>

<script>
import Toast from '../../components/Toast.vue';
import Modal from './Modal.vue';
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import {
  getVfqClinetData,
} from '../../../src/api/index.js';
echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  CanvasRenderer,
  UniversalTransition
]);
export default {
  name: "home",
  data() {
    return {
      wxllq: false,
      friendShare: false,
      showModal: false,
      isData: 1,
      indexList: [1, 2, 3, 4,],
      active: 0,
      ischange: false,
      show: false,
      mypopup: false,
      columns: ['开票金额', '开票数量', '红冲金额', '作废金额'],
      columnszd: ['money_count', 'quantity_count', 'hcfp_amt', 'invldfp_amt'],
      columnsindex: 0,
      swinfo: {},
      fpinfo: {},
      sfinfo: {},
      gsinfo: {},
      sfsfinfo: {},
      sfinfoobj: {},
      dtinfo: {},
      fold1: false,
      fold2: false,
      fold3: false,
      fold4: false,
      fold5: false,
      fold6: false,
      fold7: false,
      fold8: false,
      fold9: false,
      mainss: null,
      mainss1: null,
      title: '立案详情',
      qsarr: [],
      swarr: [],
      znjarr: [],
      showinfoobj: {},
      bginfo: {},
      colesshowinfo: false,
      taxAccountingData: '',
      returnExtendData: '',
      llqtype: false,
      addTimeYmd: ''
    };
  },

  methods: {
    getsharetype() {
      if (this.wxllq) {
        this.showModal = true
      } else {
        this.copy()
      }
    },
    copy() {
      this.showModal = false
      // 获取要复制的文本
      var textToCopy = location.href
      textToCopy = textToCopy.replace("/mobile", "/home");
      // 检查 Clipboard API 是否可用
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(() => {
          // this.$message({
          // 	message: '已复制分享链接，可转发给其他人进行税务查询！',
          // 	type: 'success'
          // });
          this.$refs.toast.show('已复制分享链接，可转发给其他人查看');
        }).catch((error) => {
          console.error('复制文本时发生错误:', error);
          this.$refs.toast.show('转发报告功能暂不支持当前浏览器版本,请使用浏览器的分享功能进行转发。');
        });
      } else {
        // Clipboard API 不可用的回退处理
        var textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          // this.$message({
          // 	message: '已复制分享链接，可转发给其他人进行税务查询！',
          // 	type: 'success'
          // });
          this.$refs.toast.show('已复制分享链接，可转发给其他人查看');

        } catch (error) {
          console.error('回退方法复制文本时发生错误:', error);
        }
        document.body.removeChild(textArea);
      }
    },
    copy1() {
      // 获取要复制的文本
      var textToCopy = this.$route.query.taxReportCode
      // 检查 Clipboard API 是否可用
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(() => {
          // this.$message({
          // 	message: '已复制分享链接，可转发给其他人进行税务查询！',
          // 	type: 'success'
          // });
          this.$refs.toast.show('已复制报告编号');
        }).catch((error) => {
          console.error('复制文本时发生错误:', error);
          this.$refs.toast.show('转发报告功能暂不支持当前浏览器版本,请使用浏览器的分享功能进行转发。');
        });
      } else {
        // Clipboard API 不可用的回退处理
        var textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          // this.$message({
          // 	message: '已复制分享链接，可转发给其他人进行税务查询！',
          // 	type: 'success'
          // });
          this.$refs.toast.show('已复制报告编号');

        } catch (error) {
          console.error('回退方法复制文本时发生错误:', error);
        }
        document.body.removeChild(textArea);
      }
    },
    wxback() {
      wx.miniProgram.reLaunch({
        url: '/pages/userauto/userauto' // 小程序目标页面路径
      });
    },
    onConfirm(value, index) {
      this.columnsindex = index
      this.mypopup = false
      this.setEchartsOptions()

    },
    showgsinfo(item, title) {
      console.log(item)
      this.title = title
      if (title == '立案详情') {
        this.sfinfoobj = item;

      }
      if (title == '当前欠税') {
        this.qsarr = item;

      }
      if (title == '税务处罚') {
        this.swarr = item;

      }
      if (title == '滞纳金') {
        this.znjarr = item;

      }
      if (title == '变更详情') {
        this.bginfo = item;

      }
      this.show = true
    },
    onCancel() {
      this.mypopup = false
    },
    scrollToPosition(index) {
      this.active = index
      document.getElementsByClassName('roll')[index].scrollIntoView()
      document.querySelector('#app').scrollTop = document.querySelector('#app').scrollTop - 45
    },
    async getVfqClinetDatafn() {
      const res = await getVfqClinetData({ taxReportCode: this.$route.query.taxReportCode })
      this.isData = res.rtnDataObj && res.rtnDataObj.length
      this.returnExtendData = res.returnExtendData || ''
      if (!this.$route.query.taxReportCode) return false
      res.rtnDataObj.forEach(el => {
        if (el.interfaceType == 6) {
          let repData = JSON.parse(el.repData);
          this.addTimeYmd = el.addTimeYmd || el.lastUpdateTimeStr;// 其他补充说明（内部信息，不对外展示）

          console.log(repData, '------------------------')
          if (repData.code == 200) {
            if (repData.data.near_3years_tax_amount && repData.data.near_3years_tax_amount.length) {
              let yearMinusThree = repData.data.near_3years_tax_amount[repData.data.near_3years_tax_amount.length - 1].year - 3;

              repData.data.near_3years_tax_amount.forEach((item, index) => {
                if (item.year <= yearMinusThree) {
                  delete repData.data.near_3years_tax_amount[index]
                }
              })

              repData.data.near_3years_tax_amount1 = repData.data.near_3years_tax_amount.reduce((acc, curr) => {
                const existingObj = acc.find(obj => obj.month == curr.month);
                if (existingObj) {
                  existingObj.money_count.push(curr.money_count);
                } else {
                  acc.push({
                    month: curr.month,
                    money_count: [curr.money_count]
                  });
                }
                return acc;
              }, []);


              repData.data.near_3years_tax_amountresult = repData.data.near_3years_tax_amount.reduce((acc, curr) => {
                const year = curr.year;
                const moneyCount = curr.money_count;
                if (moneyCount !== null && moneyCount !== '' && moneyCount !== undefined) {
                  if (year in acc) {
                    acc[year] += moneyCount * 100;
                  } else {
                    acc[year] = moneyCount * 100;
                  }
                }

                return acc;
              }, {});

            }

            if (repData.data.overdue_fine.length) {
              repData.data.overdue_fine.sort(function (a, b) {
                var date1 = new Date(a.tax_time && a.tax_time.split('--')[0]);
                var date2 = new Date(b.tax_time && b.tax_time.split('--')[0]);
                return date2 - date1;
              });
            }



            this.swinfo = repData.data
            this.taxAccountingData = el.taxAccountingData ? JSON.parse(el.taxAccountingData) : ''
            console.log(this.taxAccountingData);
          }
        }
        if (el.interfaceType == 7) {
          let repData = JSON.parse(el.repData);
          if (repData.code == 200) {



            if (repData.data.near_3years_invoice && repData.data.near_3years_invoice.length) {
              repData.data.near_3years_invoice1 = repData.data.near_3years_invoice.reduce((acc, curr) => {
                const existingObj = acc.find(obj => obj.month == curr.month);
                if (existingObj) {
                  existingObj.money_count.push(curr.money_count);
                  existingObj.invldfp_amt.push(curr.invldfp_amt);
                  existingObj.quantity_count.push(curr.quantity_count);
                  existingObj.hcfp_amt.push(curr.hcfp_amt);
                } else {
                  acc.push({
                    month: curr.month,
                    money_count: [curr.money_count],
                    hcfp_amt: [curr.hcfp_amt],
                    quantity_count: [curr.quantity_count],
                    invldfp_amt: [curr.invldfp_amt]
                  });
                }
                return acc;
              }, []);

              repData.data.near_3years_invoiceresult = repData.data.near_3years_invoice.reduce((acc, curr) => {
                const year = curr.year;
                const moneyCount = curr.money_count;
                const quantityCount = curr.quantity_count;
                const invldfpAmt = curr.invldfp_amt;
                const hcfpAmt = curr.hcfp_amt;

                if (year in acc) {
                  if (moneyCount !== null && moneyCount !== '' && moneyCount !== undefined) {
                    acc[year].money_count = Number(acc[year].money_count) + (moneyCount * 100);
                  }
                  acc[year].quantity_count += quantityCount * 100;
                  acc[year].invldfp_amt += invldfpAmt * 100;
                  acc[year].hcfp_amt += hcfpAmt * 100;
                } else {
                  acc[year] = {
                    money_count: moneyCount !== null && moneyCount !== '' ? moneyCount * 100 : '',
                    quantity_count: quantityCount * 100,
                    invldfp_amt: invldfpAmt * 100,
                    hcfp_amt: hcfpAmt * 100
                  };
                }

                return acc;
              }, {});



            }




            this.fpinfo = repData.data

          }

        }
        if (el.interfaceType == 9) {
          let repData = JSON.parse(el.repData);
          if (repData.code == 200) {
            this.sfinfo = repData.data

          }

        }
        if (el.interfaceType == 20) {
          let repData = JSON.parse(el.repData);
          if (repData.code == 200) {
            this.gsinfo = repData.data
            try {
              // parent.document.title = repData.data.company_name+'的客户报告';

            } catch (err) {

            }
          }
        }
        if (el.interfaceType == 40) {
          let repData = JSON.parse(el.repData);
          if (repData.code == 200) {
            this.dtinfo = repData.data

          }
        }
        if (el.interfaceType == 11) {
          let repData = JSON.parse(el.repData);
          if (repData.code == 200) {
            this.sfsfinfo = repData.data

          }
        }
      });
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.swinfo.near_3years_tax_amount1 && this.swinfo.near_3years_tax_amount1.length) {
            this.setEcharts(this.swinfo.near_3years_tax_amount1, 'mainss')

          }
          if (this.fpinfo.near_3years_invoice1 && this.fpinfo.near_3years_invoice1.length) {
            this.setEcharts(this.fpinfo.near_3years_invoice1, 'mainss1')

          }


          var scrollDiv = document.getElementById('app');
          scrollDiv.addEventListener('scroll', () => {
            var wst = scrollDiv.scrollTop
            var navLen = document.querySelectorAll('.roll').length;
            for (var i = 0; i < navLen; i++) {
              //加循环
              if (document.querySelectorAll('.roll')[i].offsetTop <= wst - 60) {
                this.active = i
              }
            }
          });
        }, 0);
      })
    },
    setEchartsOptions() {   //生成ECharts
      let arr = ['money_count', 'quantity_count', 'hcfp_amt', 'invldfp_amt']
      let rqdata = []
      let data1 = []
      let data2 = []
      let data3 = []
      this.fpinfo.near_3years_invoice1.forEach((item, index) => {
        rqdata.push(item.month + '月');
        data1.push(item[arr[this.columnsindex]][0]);
        data2.push(item[arr[this.columnsindex]][1]);
        data3.push(item[arr[this.columnsindex]][2]);
      })
      let year = ''
      if (this.swinfo.near_3years_tax_amount && this.swinfo.near_3years_tax_amount.length) {
        year = this.swinfo.near_3years_tax_amount[this.swinfo.near_3years_tax_amount.length - 1].year

      }
      var option;

      option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '5%',
          bottom: '0%',
          top: '5%',
          containLabel: true
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: rqdata
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: year,
            type: 'line',

            data: data3
          },
          {
            name: year - 1,
            type: 'line',

            data: data2
          },
          {
            name: year - 2,
            type: 'line',

            data: data1
          }
        ],
        color: ['#196dff', '#ffa319', '#14cdb4']
      };
      this.mainss1.setOption(option);
      this.mainss1.resize(); //重绘,动态获取options时不会出现渲染异常
    },
    showinfos(item) {
      this.colesshowinfo = true
      this.showinfoobj = item
    },
    formatValue(value, isfalse = false) {
      if (value === null || value === '' || value === false || value === undefined) {
        return '---';
      } else {
        if (isfalse == 1) {
          return Math.round(value);

        } else if (isfalse == 2) {
          return value && Number(value).toFixed(2);

        } else {
          return value;

        }
      }
    },
    setEcharts(data, id) {
      let rqdata = []
      let data1 = []
      let data2 = []
      let data3 = []
      data.forEach((item, index) => {
        rqdata.push(item.month + '月');
        data1.push(item.money_count[0]);
        data2.push(item.money_count[1]);
        data3.push(item.money_count[2]);
      })
      var chartDom = document.getElementById(id);
      this[id] = echarts.init(chartDom);

      let year = ''
      if (this.swinfo.near_3years_tax_amount && this.swinfo.near_3years_tax_amount.length) {
        year = this.swinfo.near_3years_tax_amount[this.swinfo.near_3years_tax_amount.length - 1].year

      }
      var option;

      option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '5%',
          bottom: '0%',
          top: '5%',
          containLabel: true
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: rqdata
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: year,
            type: 'line',

            data: data3
          },
          {
            name: year - 1,
            type: 'line',

            data: data2
          },
          {
            name: year - 2,
            type: 'line',

            data: data1
          }
        ],
        color: ['#196dff', '#ffa319', '#14cdb4']
      };

      option && this[id].setOption(option);

    }
  },
  computed: {
    cnear_3years_tax_amount() {
      if (this.fold3) {
        return this.swinfo.near_3years_tax_amount1
      } else {
        return this.swinfo.near_3years_tax_amount1.filter((item, index) => index < 4)
      }
    },
    cnear_3years_invoice() {
      if (this.fold5) {
        return this.fpinfo.near_3years_invoice1
      } else {
        return this.fpinfo.near_3years_invoice1.filter((item, index) => index < 4)
      }
    },
    top10_customer_info() {
      if (this.fold6 && this.fpinfo.top10_customer_info) {
        return this.fpinfo.top10_customer_info
      }
      if (!this.fold6 && this.fpinfo.top10_customer_info) {
        return this.fpinfo.top10_customer_info.filter((item, index) => index < 4)
      }
      return []
    },
    top10_supplier_info() {
      if (this.fold7 && this.fpinfo.top10_supplier_info) {
        return this.fpinfo.top10_supplier_info
      }
      if (!this.fold7 && this.fpinfo.top10_supplier_info) {
        return this.fpinfo.top10_supplier_info.filter((item, index) => index < 4)
      }
      return []
    },
    case_filing() {
      if (this.fold9) {
        return this.sfsfinfo.case_filing
      } else {
        return this.sfsfinfo.case_filing.filter((item, index) => index < 4)
      }
    },

  },
  created() {
    this.getVfqClinetDatafn()
  },
  beforeCreate() {
    // const info = this.$route.query
    // if(info.moblie && info.tenement_id) {
    //   this.$store.dispatch('getmobile_tenement_id',info)
    // } else {
    //   this.$router.push({ path: '/404' })
    // }
  },
  components: {
    Toast,
    Modal
  },
  mounted() {

    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.wxllq = true
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          this.llqtype = true
        } else {
          this.llqtype = false

        }
      })
    } else {
      this.llqtype = false

    }

  }
};
</script>
<style lang="less" scoped>
@media screen and (min-width: 1200px) {
  .empty-info {
    width: 400px !important;
  }

  /* 创建一个自定义的滚动条容器 */
  .scroll-container {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    /* 使滚动更加顺滑 */
    height: 100vh;
    /* 高度设置为全屏 */
    width: 100%;
    /* 宽度设置为100% */
    position: relative;
  }

  /* 自定义滚动条样式 */
  .scroll-container::-webkit-scrollbar {
    width: 0;
    /* 隐藏滚动条 */
  }

  /* 为滚动条增加轨道 */
  .scroll-container::-webkit-scrollbar-track {
    background: transparent;
  }

  /* 自定义滚动条的滑块 */
  .scroll-container::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.5);
    /* 滑块的颜色 */
    border-radius: 10px;
    /* 圆角效果 */
  }

  .scroll-container::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.7);
    /* 滑块在悬停时的颜色 */
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.btnbox {
  display: flex;
  padding: 40px 20px;
}

.btnbox div {
  padding: 40px 30px;
  background: #ED701F;
  color: #fff;
  margin: 0 10px;
  border-radius: 10px;
  font-weight: 800;
  font-size: 16px;
  cursor: pointer;
}

:root {
  --van-black: #000;
  --van-white: #fff;
  --van-gray-1: #f7f8fa;
  --van-gray-2: #f2f3f5;
  --van-gray-3: #ebedf0;
  --van-gray-4: #dcdee0;
  --van-gray-5: #c8c9cc;
  --van-gray-6: #969799;
  --van-gray-7: #646566;
  --van-gray-8: #323233;
  --van-red: #ee0a24;
  --van-blue: #1989fa;
  --van-orange: #ff976a;
  --van-orange-dark: #ed6a0c;
  --van-orange-light: #fffbe8;
  --van-green: #07c160;
  --van-gradient-red: linear-gradient(90deg, #ff6034, #ee0a24);
  --van-gradient-orange: linear-gradient(90deg, #ffd01e, #ff8917);
  --van-primary-color: var(--van-blue);
  --van-success-color: var(--van-green);
  --van-danger-color: var(--van-red);
  --van-warning-color: var(--van-orange);
  --van-text-color: var(--van-gray-8);
  --van-text-color-2: var(--van-gray-6);
  --van-text-color-3: var(--van-gray-5);
  --van-text-link-color: #576b95;
  --van-active-color: var(--van-gray-2);
  --van-active-opacity: .6;
  --van-disabled-opacity: .5;
  --van-background-color: var(--van-gray-1);
  --van-background-color-light: var(--van-white);
  --van-padding-base: 1.06667vw;
  --van-padding-xs: 2.13333vw;
  --van-padding-sm: 3.2vw;
  --van-padding-md: 4.26667vw;
  --van-padding-lg: 6.4vw;
  --van-padding-xl: 8.53333vw;
  --van-font-size-xs: 2.66667vw;
  --van-font-size-sm: 3.2vw;
  --van-font-size-md: 3.73333vw;
  --van-font-size-lg: 4.26667vw;
  --van-font-weight-bold: 500;
  --van-cell-font-size: var(--van-font-size-md);
  --van-cell-line-height: 6.4vw;
  --van-cell-vertical-padding: 2.66667vw;
  --van-cell-horizontal-padding: var(--van-padding-md);
  --van-cell-text-color: var(--van-text-color);
  --van-cell-background-color: var(--van-background-color-light);
  --van-cell-border-color: var(--van-border-color);
  --van-cell-active-color: var(--van-active-color);
  --van-cell-required-color: var(--van-danger-color);
  --van-cell-label-color: var(--van-text-color-2);
  --van-cell-label-font-size: var(--van-font-size-sm);
  --van-cell-label-line-height: var(--van-line-height-sm);
  --van-cell-label-margin-top: var(--van-padding-base);
  --van-cell-value-color: var(--van-text-color-2);
  --van-cell-icon-size: 4.26667vw;
  --van-cell-right-icon-color: var(--van-gray-6);
  --van-cell-large-vertical-padding: var(--van-padding-sm);
  --van-cell-large-title-font-size: var(--van-font-size-lg);
  --van-cell-large-label-font-size: var(--van-font-size-md);

}

.home {
  font-size: 12px;
  position: relative;
  width: 100%;
  margin: 0;
  background-color: #f0f1f5;

  .h375 {
    height: 100vw;
  }

  .report-header-comp {
    position: relative;
    z-index: 99;
    width: 100%;
    background-size: cover;
  }

  .report-header-comp .content.t168 {
    top: 44.8vw;
  }

  .report-header-comp .content {
    min-height: 53.33333vw;
    position: absolute;
    left: 3.2vw;
    width: 93.6vw;
    background-color: #fff;
    border-radius: 2.13333vw;
  }

  .report-header-comp .content .base-info {
    padding-bottom: 4.26667vw;
    border-bottom: 1px dashed rgba(216, 219, 234, .7);
    font-size: 0;
    text-align: center;
  }

  .report-header-comp .content .base-info .company-name {
    padding-top: 8vw;
    color: #25292e;
    text-align: center;
    font-size: 5.86667vw;
    font-weight: 700;
    line-height: 8vw;
  }

  .report-header-comp .content .base-info .enterprise-desc,
  .report-header-comp .content .base-info .max-amount {
    padding-top: 2.66667vw;
    color: #7b808b;
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    text-align: center;
  }

  .report-header-comp .content .match-info {
    position: absolute;
    left: 2.13333vw;
    top: -9.6vw;
    color: #e0f0ff;
    font-size: 3.2vw;
    line-height: 4.53333vw;
  }

  .bg-layer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 98;
    overflow: hidden;
  }

  .bg-layer .bg-image {
    width: 100%;
    height: 98.66667vw;
    position: absolute;
    top: 0;
    left: 0;
  }

  .bg-layer .bg-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .body.top324 {
    top: 86.4vw;
  }

  .body {
    position: absolute;
    z-index: 99;
    width: 100%;
    background-color: #fff;
    border-top-left-radius: 2.13333vw;
    border-top-right-radius: 2.13333vw;
    box-shadow: 0 -0.53333vw 2.13333vw 1px rgba(0, 0, 0, .08);
  }

  .body .analysis-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4.26667vw 3.2vw 3.46667vw;
    background-color: #fff;
    border-top-left-radius: 2.13333vw;
    border-top-right-radius: 2.13333vw;
    border-bottom: 1px dashed rgba(216, 219, 234, .7);
  }

  .body .analysis-title>p {
    display: flex;
    align-items: center;
    font-size: 4.26667vw;
    font-weight: 700;
    color: #25292e;
    letter-spacing: .8px;
    line-height: 5.86667vw;
  }

  .body .analysis-title>p img {
    width: 4.26667vw;
    margin-right: 2.13333vw;
  }

  .body .analysis-title>p {
    display: flex;
    align-items: center;
    font-size: 4.26667vw;
    font-weight: 700;
    color: #25292e;
    letter-spacing: .8px;
    line-height: 5.86667vw;
  }

  .body .analysis-title .credit-entrance {
    display: flex;
    align-items: center;
  }

  .report-detail-container {
    width: 100%;
    margin: 0;
  }

  .report-detail-container .bodys {
    padding-top: 2.66667vw;
  }

  .report-detail-container .bodys .menu-area {
    margin: 0;
    cursor: pointer;
  }

  .report-menu-comp .selected-menu-item {
    position: relative;
  }

  .report-menu-comp .menu-item {
    flex: 1;
    padding: 3.2vw 0;
    text-align: center;
  }

  .report-menu-comp {
    width: 100%;
    margin: 0;
    background-color: #fff;
    box-shadow: 0 0.53333vw 1.33333vw -0.53333vw #eee;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .report-menu-comp .selected-menu-item p {
    color: var(--mppThemeColor, #196dff);
  }

  .report-menu-comp .menu-item p {
    font-size: 3.46667vw;
    color: #25292e;
  }

  .report-menu-comp .selected-menu-item:after {
    content: "";
    width: 3.2vw;
    height: 1.06667vw;
    border-radius: 2.13333vw;
    background-color: var(--mppThemeColor, #196dff);
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .report-detail-container .content-area>.interval {
    width: 100%;
    height: 2.13333vw;
    background-color: #f0f1f5;
  }

  .info-title {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 999;
    font-size: 4.26667vw;
    font-weight: 700;
    color: #25292e;
    padding: 3.46667vw 0;
    margin: 0 3.2vw;
    border-bottom: 1px dashed rgba(216, 219, 234, .7);
  }

  .info-title img {
    width: 4.26667vw;
    margin-right: 2.13333vw;
  }

  .report-detail-container .content-area .base-info .info-title,
  .report-detail-container .content-area .product-info .info-title,
  .report-detail-container .content-area .tax-info .info-title,
  .report-detail-container .content-area .ticket-info .info-title {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 999;
    font-size: 4.26667vw;
    font-weight: 700;
    color: #25292e;
    padding: 3.46667vw 0;
    margin: 0 3.2vw;
    border-bottom: 1px dashed rgba(216, 219, 234, .7);
  }

  .custom-table-comp {
    width: 100%;
    margin: 0;
  }

  .custom-table-comp {
    position: relative;
    padding: 1.86667vw 3.2vw 3.46667vw;
  }

  .custom-table-comp .van-cell {
    padding: 3.46667vw 0;
    font-size: 3.46667vw;
    line-height: 4.8vw;
  }

  .van-cell {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: var(--van-cell-vertical-padding) var(--van-cell-horizontal-padding);
    overflow: hidden;
    color: var(--van-cell-text-color);
    font-size: var(--van-cell-font-size);
    line-height: var(--van-cell-line-height);
    background: var(--van-cell-background-color);
  }

  .custom-table-comp .van-cell .van-cell__title {
    color: #7b808b;
  }

  .van-cell__title,
  .van-cell__value {
    flex: 1;
  }

  .custom-table-comp .van-cell .van-cell__value {
    position: relative;
    z-index: 999;
    color: #25292e;
    font-weight: 500;
  }

  .van-cell__value {
    position: relative;
    overflow: hidden;
    color: var(--van-cell-value-color);
    text-align: right;
    vertical-align: middle;
    word-wrap: break-word;
  }

  .more .van-icon {
    font-size: 3.2vw;
  }

  .van-icon {
    font: 3.73333vw/1 vant-icon;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
  }

  .van-badge__wrapper,
  .van-icon {
    position: relative;
    display: inline-block;
  }


  .report-number-btn {
    background-color: #FF6B00;
    border-radius: 15px 0 0 15px;
    display: flex;
    width: 160px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;


  }

  .report-number-btn span {
    font-size: 12px;
    color: #FFFFFF;
  }

  .report-number-btn img {
    width: 20px;
    height: 20px;
  }

  .more {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16vw;
    height: 6.4vw;
    margin: 3.2vw auto 0;
    background: var(--mppMoreBgColor, rgba(25, 109, 255, .08));
    border-radius: 3.2vw 3.2vw 3.2vw 3.2vw;
    color: var(--mppThemeColor, #196dff);
    line-height: 6.4vw;
    text-align: center;
    font-size: 3.2vw;
    cursor: pointer;
  }

  .subtable-thead {
    display: flex;
    align-items: stretch;
    background: rgba(242, 247, 255, .7);
  }

  .subtable-content-item {
    display: flex;
    justify-content: start;
    align-items: stretch;
  }

  .subtable-thead .thead-item:first-child {
    border-left: 1px solid #eee;
  }

  .subtable-thead .thead-item {
    min-height: 11.73333vw;
    padding: 1.33333vw;
    border-top: 1px solid #eee;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .subtable-content-item {
    display: flex;
    justify-content: start;
    align-items: stretch;
  }

  .subtable-thead .thead-item>p {
    font-size: 3.2vw;
    color: #666;
    word-break: break-all;
    text-align: center;
  }

  .subtable-content-item .subtable-info-item>p {
    font-size: 3.2vw;
    color: #666;
    word-break: break-all;
    text-align: center;
  }

  .van-multi-ellipsis--l3 {
    -webkit-line-clamp: 3;
  }

  .van-multi-ellipsis--l2,
  .van-multi-ellipsis--l3 {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }

  .subtable-content-item .subtable-info-item {
    min-height: 11.73333vw;
    padding: 1.33333vw;
    border-right: 1px solid #eee;
    border-left: 1px solid #eee;
    border-bottom: 1px solid #eee;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .judicial-info {
    width: 100%;
    margin: 0;
  }

  .judicial-info {
    position: relative;
    padding: 1.86667vw 3.2vw 3.46667vw;
  }

  .judicial-info .count {
    padding: 3.46667vw 0;
    color: #7b808b;
    font-size: 3.46667vw;
  }

  .subtable-content-item:nth-child(2n) {
    background: rgba(242, 247, 255, .7);
  }

  .tax-info {
    width: 100%;
    margin: 0;
  }

  .tax-info {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 2.66667vw 3.2vw 3.46667vw;
    border-bottom: 1px dashed rgba(216, 219, 234, .7);
  }

  .tax-info .info-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 4.8vw;
  }

  .tax-info .info-item .label {
    padding-bottom: 2.13333vw;
    color: #7b808b;
    font-size: 3.2vw;
  }

  .tax-info .info-item .label,
  .tax-info .info-item .value {
    position: relative;
    z-index: 999;
  }

  .tax-info .info-item .value {
    color: #25292e;
    font-size: 3.73333vw;
    font-weight: 500;
  }

  .tax-info .info-item .label,
  .tax-info .info-item .value {
    position: relative;
    z-index: 999;
  }

  .data-table-comp {
    width: 100%;
    overflow: scroll;
    margin: 5.33333vw 0 3.46667vw;
  }

  .data-table-comp table {
    width: 100vw;
    font-size: 0;
  }

  .data-table-comp table thead {
    background: rgba(242, 247, 255, .7);
  }

  tr {
    height: 11.73333vw !important;
  }

  .data-table-comp table tbody tr td:first-child,
  .data-table-comp table tbody tr th:first-child,
  .data-table-comp table tfoot tr td:first-child,
  .data-table-comp table tfoot tr th:first-child,
  .data-table-comp table thead tr td:first-child,
  .data-table-comp table thead tr th:first-child {
    font-size: 3.46667vw;
    font-weight: 400;
    background-color: #fff;
    position: sticky;
    left: 0;
  }

  .data-table-comp table thead th:first-child {
    background: rgba(242, 247, 255, .7) !important;
  }

  .data-table-comp table tbody tr th,
  .data-table-comp table tfoot tr th,
  .data-table-comp table thead tr th {
    color: #7b808b;
    font-size: 3.46667vw;
  }

  .data-table-comp table tbody tr td,
  .data-table-comp table tbody tr th,
  .data-table-comp table tfoot tr td,
  .data-table-comp table tfoot tr th,
  .data-table-comp table thead tr td,
  .data-table-comp table thead tr th {
    padding: 1.06667vw 0.8vw;
  }

  .data-table-comp .more {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28.53333vw;
    height: 6.4vw;
    margin: 3.2vw auto 0;
    background: var(--mppMoreBgColor, rgba(25, 109, 255, .08));
    border-radius: 3.2vw 3.2vw 3.2vw 3.2vw;
    color: var(--mppThemeColor, #196dff);
    line-height: 6.4vw;
    text-align: center;
    font-size: 3.2vw;
  }

  .data-table-comp table tbody tr td:first-child div,
  .data-table-comp table tbody tr th:first-child div,
  .data-table-comp table tfoot tr td:first-child div,
  .data-table-comp table tfoot tr th:first-child div,
  .data-table-comp table thead tr td:first-child div,
  .data-table-comp table thead tr th:first-child div {
    width: 11.73333vw;
  }

  .sales-info-comp {
    width: 100%;
  }

  .data-table-comp table tbody tr td div,
  .data-table-comp table tbody tr th div,
  .data-table-comp table tfoot tr td div,
  .data-table-comp table tfoot tr th div,
  .data-table-comp table thead tr td div,
  .data-table-comp table thead tr th div {
    width: calc(24vw - 0.33333px);
    text-align: center;
    word-break: break-all;
    white-space: normal;
  }

  .data-table-comp table tbody tr:nth-child(2n) td,
  .data-table-comp table tbody tr:nth-child(2n) {
    background: rgba(242, 247, 255, .7);
  }

  .sales-info-comp .title-one,
  .sales-info-comp .title-three,
  .sales-info-comp .title-two {
    padding: 2.93333vw 2.66667vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .sales-info-comp .title-one .left,
  .sales-info-comp .title-three .left {
    color: #25292e;
    font-size: 3.73333vw;
    font-weight: 700;
  }

  .sales-info-comp .title-one .left,
  .sales-info-comp .title-three .left,
  .sales-info-comp .title-two .left {
    flex: 1;
  }

  .sales-info-comp .title-one .right,
  .sales-info-comp .title-three .right,
  .sales-info-comp .title-two .right {
    flex-shrink: 0;
  }

  .sales-info-comp .title-one .right .picker,
  .sales-info-comp .title-three .right .picker,
  .sales-info-comp .title-two .right .picker {
    height: 8vw;
    padding: 0 4vw;
    border: 1px solid #dbe3ea;
    border-radius: 4vw;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .sales-info-comp .title-one .right .picker .name,
  .sales-info-comp .title-three .right .picker .name,
  .sales-info-comp .title-two .right .picker .name {
    font-size: 3.2vw;
    margin-right: 0.8vw;
    color: #333;
  }

  .sales-info-comp .title-one .right .picker .icon-down,
  .sales-info-comp .title-three .right .picker .icon-down,
  .sales-info-comp .title-two .right .picker .icon-down {
    width: 2.66667vw;
    height: 1.6vw;
  }

  .sales-info-comp .title-three .right,
  .sales-info-comp .title-two .right {
    display: flex;
  }

  .sales-info-comp .title-three .right .year-item,
  .sales-info-comp .title-two .right .year-item {
    display: flex;
    align-items: center;
    padding-left: 2.93333vw;
  }

  .sales-info-comp .title-three .right .year-item:first-child .block,
  .sales-info-comp .title-two .right .year-item:first-child .block {
    background: #196dff;
  }

  .sales-info-comp .title-three .right .year-item .block,
  .sales-info-comp .title-two .right .year-item .block {
    width: 3.2vw;
    height: 3.2vw;
    margin-right: 0.53333vw;
    border-radius: 0.53333vw;
  }

  .sales-info-comp .title-three .right .year-item span,
  .sales-info-comp .title-two .right .year-item span {
    color: #7b808b;
    font-size: 3.2vw;
  }

  .sales-info-comp .title-three .right .year-item:nth-child(2) .block,
  .sales-info-comp .title-two .right .year-item:nth-child(2) .block {
    background: #ffa319;
  }

  .sales-info-comp .title-three .right .year-item:nth-child(3) .block,
  .sales-info-comp .title-two .right .year-item:nth-child(3) .block {
    background: #14cdb4;
  }

  .sales-info-comp .title-one,
  .sales-info-comp .title-three,
  .sales-info-comp .title-two {
    padding: 2.93333vw 2.66667vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .near-one-customer-info .subtable-content-item .subtable-info-item img {
    width: 6.4vw;
  }

  .report-detail-container .content-area .base-info .product-analysis-title,
  .report-detail-container .content-area .product-info .product-analysis-title,
  .report-detail-container .content-area .tax-info .product-analysis-title,
  .report-detail-container .content-area .ticket-info .product-analysis-title {
    display: flex;
    justify-content: center;
    padding: 3.46667vw 3.2vw 3.73333vw;
    border-bottom: 1px solid rgba(216, 219, 234, .3);
  }

  .report-detail-container .content-area .base-info .product-analysis-title img,
  .report-detail-container .content-area .product-info .product-analysis-title img,
  .report-detail-container .content-area .tax-info .product-analysis-title img,
  .report-detail-container .content-area .ticket-info .product-analysis-title img {
    width: 32.26667vw;
    object-fit: cover;
  }

  .product-analysis-list-comp {
    width: 100%;
    margin: 0;
    padding-bottom: 1px;
    background-color: #f0f1f5;
  }

  .product-analysis-list-comp .analysis-status-box {
    padding: 2.13333vw 3.2vw;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #fff;
  }

  .product-analysis-list-comp .analysis-status-box .judge-status-selected {
    background-color: var(--mppThemeColor, #196dff) !important;
    border-radius: 1.06667vw;
    color: #FFF !important;
  }

  .product-analysis-list-comp .analysis-status-box .judge-status-item {
    flex: 1;
    height: 10.66667vw;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
    margin-right: 2.13333vw;
    border-radius: 1.06667vw;
  }

  .product-analysis-item-comp {
    width: 93.6vw;
    margin: 0 3.2vw 2.13333vw;
    padding: 4.26667vw 2.13333vw 0;
    background-color: #fff;
    border-radius: 2.13333vw;
  }

  .product-analysis-item-comp .header {
    width: 100%;
    padding-bottom: 4.26667vw;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3.2vw;
    border-bottom: 1px dashed rgba(216, 219, 234, .7);
  }

  .product-analysis-item-comp .header .product-name {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product-analysis-item-comp .header .product-name>div {
    flex-shrink: 0;
    width: 6.4vw;
    height: 6.4vw;
    border-radius: 0.66667vw;
    background-color: #6369e2;
    margin-right: 2.13333vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product-analysis-item-comp .header .product-name>p {
    flex: 1;
    font-size: 4.26667vw;
    font-weight: 700;
    color: #25292e;
    letter-spacing: .6px;
  }

  .product-analysis-item-comp .header>span {
    flex-shrink: 0;
    font-size: 3.73333vw;
    color: var(--mppThemeColor, #196dff);
    letter-spacing: .6px;
  }

  .van-icon {
    font: 3.73333vw/1 vant-icon;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
  }

  .van-badge__wrapper,
  .van-icon {
    position: relative;
    display: inline-block;
  }

  .product-analysis-item-comp .fbody {
    padding: 3.46667vw;
    padding-top: 0;
  }

  .product-analysis-item-comp .fbody .interest-rate,
  .product-analysis-item-comp .fbody .loan {
    padding-bottom: 5.33333vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .product-analysis-item-comp .fbody .interest-rate .cycle,
  .product-analysis-item-comp .fbody .interest-rate .evaluate,
  .product-analysis-item-comp .fbody .interest-rate .loan-max,
  .product-analysis-item-comp .fbody .interest-rate .rate,
  .product-analysis-item-comp .fbody .loan .cycle,
  .product-analysis-item-comp .fbody .loan .evaluate,
  .product-analysis-item-comp .fbody .loan .loan-max,
  .product-analysis-item-comp .fbody .loan .rate {
    flex: 1;
    font-size: 3.2vw;
    color: #ffa00a;
  }

  .data-table-comp .title {
    padding: 2.13333vw 3.2vw;
    color: #25292e;
    font-size: 3.73333vw;
    font-weight: 700;
  }

  #mainss,
  #mainss1 {
    width: 100%;
    height: 270px;
  }

  // .tax-info .more {
  //   display: flex;
  //   justify-content: center;
  //   width: 100%;
  //   background: #FFF;
  // }

  .tax-info .more .content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16vw;
    height: 6.4vw;
    margin: 0 auto;
    background: var(--mppMoreBgColor, rgba(25, 109, 255, .08));
    border-radius: 3.2vw 3.2vw 3.2vw 3.2vw;
    color: var(--mppThemeColor, #196dff);
    line-height: 6.4vw;
    text-align: center;
    font-size: 3.2vw;
  }

  .near-one-customer-info {
    padding: 1.86667vw 3.2vw 3.46667vw;
  }

  .product-analysis-item-comp .interest-rate .cycle .label,
  .product-analysis-item-comp .interest-rate .evaluate .label,
  .product-analysis-item-comp .interest-rate .loan-max .label,
  .product-analysis-item-comp .interest-rate .rate .label,
  .product-analysis-item-comp .loan .cycle .label,
  .product-analysis-item-comp .loan .evaluate .label,
  .product-analysis-item-comp .loan .loan-max .label,
  .product-analysis-item-comp .loan .rate .label {
    color: #7b808b;
    font-size: 3.2vw;
  }

  .product-analysis-item-comp .interest-rate .cycle .value,
  .product-analysis-item-comp .interest-rate .evaluate .value,
  .product-analysis-item-comp .interest-rate .loan-max .value,
  .product-analysis-item-comp .interest-rate .rate .value,
  .product-analysis-item-comp .loan .cycle .value,
  .product-analysis-item-comp .loan .evaluate .value,
  .product-analysis-item-comp .loan .loan-max .value,
  .product-analysis-item-comp .loan .rate .value {
    padding-left: 1.33333vw;
    color: #25292e;
    font-size: 3.73333vw;
    font-weight: 500;
  }

  .product-analysis-list-comp .interval {
    width: 120%;
    height: 2.13333vw;
    margin-left: -4.26667vw;
    background-color: #f0f1f5;
  }

  .subtable-info-item p,
  .thead-item p {
    line-height: 18px;
  }


}



::v-deep .van-sticky--fixed {
  position: fixed;
  z-index: 2000;

  top: 0px;
  width: 100vw
}

::v-deep .van-index-anchor {
  display: none;
}

::v-deep .van-index-bar__sidebar {
  display: none;

}

.table-header {
  position: relative;
  text-align: center;
  padding: 3.2vw 0 2.4vw;
  flex-shrink: 0;
}

.clear {
  clear: both;
}

.table-header .close-dialog-btn {
  position: absolute;
  top: 1.2vw;
  right: 0;
  width: 4.26667vw;
  height: 4.26667vw;
  padding: 2vw;
  box-sizing: content-box;
  cursor: pointer;
  z-index: 10;
}

.table-header .table-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin: 0;
  padding: 0 8vw;
  line-height: 6vw;
  text-align: center;
}

.table-dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 80vh;
  min-height: 0;
  padding-top: 2.13333vw;
  padding-right: 4.26667vw;
  padding-bottom: 0;
  padding-left: 4.26667vw;
  box-sizing: border-box;
  overflow: hidden;
}

.dialog-scroll-box {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 2vw;
}

.dialog-scroll-box .subtable-thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

.dialog-scroll-box::-webkit-scrollbar {
  width: 4px;
}

.dialog-scroll-box::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

.dialog-scroll-box::-webkit-scrollbar-track {
  background: transparent;
}

.tax-info .info-item .value .detail {
  color: var(--mppThemeColor, #196dff);
  padding-left: 2.13333vw;
  font-size: 2.66667vw;
}

.subtable-info-item .text {
  display: block;
  width: 6.4vw;
}

.empty-info {
  text-align: center;
  padding: 13.33333vw 0 13.33333vw;
  font-size: 15px;
  background: #FFF;
}

.table-dialog-content .table {
  color: #666;
  overflow: auto;
}

.table-dialog-content .table .tr:first-child {
  border-top-left-radius: 1.33333vw;
  border-top-right-radius: 1.33333vw;
}

.table-dialog-content .table .tr:nth-child(odd) {
  background: #f9faff;
}

.table-dialog-content .table .tr {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  min-height: 11.73333vw;
}

.table-dialog-content .table .tr .td:first-child {
  width: 25.6vw;
}

.table-dialog-content .table .tr .td {
  line-height: 6.13333vw;
  padding: 1.06667vw 2.66667vw;
  font-size: 3.2vw;
  word-break: break-all;
}

.table-dialog-content .table .tr .td:last-child {
  flex: 1;
}



::v-deep .van-dialog {
  z-index: 2022;
  top: 50%;
  width: 90vw;
  max-width: 380px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
}

::v-deep .van-dialog__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.multiPoint_wrap {
  display: inline-block;
  font-size: 3.2vw;
  color: #bbb;
  padding: 1.86667vw 0 3.2vw 2.66667vw;
}

.valuestyle {
  font-size: 12px !important;
  margin-bottom: 5px;
}

.sharebtn {
  width: 120px;
  height: 40px;
  text-align: center;
  font-size: 15px;
  line-height: 40px;
  position: absolute;
  border-radius: 30px 0 0 30px;
  right: 0;
  top: 10px;
  cursor: pointer;
  color: #FFF;
  font-weight: 800;
  background-color: #e6a23c;
}
</style>
